import React from 'react'
import { useState, useEffect, useRef } from 'react';
import { Box, Stack, IconButton, Backdrop, Typography, Grid2 as Grid, Grid2, Link, TableCell, TableContainer, Table, TableBody, TableRow, FormControl, FormControlLabel, Radio, RadioGroup, Divider, FormLabel, FormGroup, Checkbox, AccordionDetails, AccordionSummary, List, ListItem, Tooltip, ListItemText, TextField, Autocomplete, Button, Dialog, DialogTitle, DialogContent, DialogActions, InputLabel, Select, MenuItem, SelectChangeEvent, TableHead } from '@mui/material'
import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import AddIcon from '@mui/icons-material/Add'
import RemoveIcon from '@mui/icons-material/Remove'
import CustomAccordion from '../../components/Accordian/accordian'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import dayjs, { Dayjs } from 'dayjs';
import { getApiErrorMessage } from '../../api/getApiErrorMessage';
import { useGetMoveInCostMutation, useGetProtectionPlanQuery, useFetchReservationDetailsQuery, useLazyGetOccupancyDataQuery, useGetStatesQuery, useGetOperatorGuidesQuery, usePatchReservationDetailsMutation } from '../../api/endpoints/apiConfig';
import { MoveInCosts, MoveInCostResponse } from '../../models/RentCost';
import TakePaymentAndRent from './TakePaymentAndRent';
import { AircallNofity } from '../../components/Common/notify';
import CircularProgress from '@mui/material/CircularProgress';
import { DataGrid, GridColDef, GridToolbarContainer, GridToolbarColumnsButton, GridToolbarDensitySelector } from '@mui/x-data-grid';
import { OccupancyData } from '../../models/OccupancyData';
import { usePostSpeedeRentMutation, useGetMerchandiseQuery, useGetAvailableUnitsDataQuery } from '../../api/endpoints/apiConfig';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { timezoneMapping } from '../../components/Dashboard/timezoneUtils';
import { toast } from 'react-toastify';
import { addId } from '../../store/reducers/aircallTagSlice';
import { useAppDispatch } from '../../hooks/useAppDispatch';
import { useLookupActiveAircallCall } from '../../hooks/useLookupActiveAircallCall';
import { merchandise } from '../../models/Merchandisedata';
import { Merchandiseparams } from '../../models/MoveInCost';
import { UpdateReservationDetails } from '../../models/UpdateReservationDetails';

interface RentAndReservationRentProps {
    type: number; // 1 for Rent, 2 for Reservation Rent
}

//id selector function for occupant firstname
function CustomToolbar() {
    return (
        <GridToolbarContainer>
            <GridToolbarColumnsButton />
            <GridToolbarDensitySelector
                slotProps={{ tooltip: { title: 'Change density' } }}
            />
        </GridToolbarContainer>
    );
}

//Convert time Zone 
dayjs.extend(utc);
dayjs.extend(timezone);
interface fee {
    "external_id": ""
    "name": "",
    "cost": "",
    "tax": ""
}

interface RecurringPeriodItem {
    key: string;
    title: string;
    rent: number;
    promotion: number;
    insurance: number;
    fees: number;
    tax: number;
    total: number;
}

const PERIODS_BLOCK_ERROR_MESSAGE = 'Error - Payment Periods must be 0 to move-in.';

// model for bind movin datas
const rentapi = {
    "customerinfofirstname": "",
    "customerinfolastname": "",
    "customerinfoaddress1": "",
    "customerinfoaddress2": "",
    "customerinfocity": "",
    "customerinfostate": "",
    "customerinfoPostalcode": "",
    "customerinfophone": "",
    "customerinfoemail": "",
    "IdType": "",
    "IdTNumber": "",
    "IdIssuer": "",
    "emergencyContactfirstname": "",
    "emergencyContactlastname": "",
    "emergencyContactphone": "",
    "militaryStatus": "",
    "militaryStatusbranch": "",
    "militaryStatusidnumber": "",
    "isLians": "no",
    "ProperityBeingStored": "",
    "selectinsurence": "",
    "comments": "",
    "occupancyid": "",
    "external_id": "",
    "ExternalUnitId": 0,
    "promoid": "",
    "start_date": dayjs().format('YYYY-MM-DD'),
    "endDate": "",
    "Move_in_cost": 0,
    "promoname": "",
    "promoprice": "",
    "prodection_external_id": "",
    "is_insurable": true as boolean | null,
    "selectedMonth": "This Month",
    "is_promo_deferred": false,
    "creditfirstname": "",
    "creditlastname": "",
    "CredictCardNumber": "",
    "ExpiryMonth": "",
    "ExpiryYear": "",
    "CVV": "",
    "card_zip": "",
    "card_type": "",
    "UnitSize": "",
    "Features": "",
    "MonthlyRate": "",
    "Promotion": "",
    "PromotionStart": "",
    "UnitNumber": "",
    "FirstMonthRent": "",
    "AdministrativeFee": 0,
    "TenantprotectionPlan": "",
    "RentTax": 0,
    "DueNow": 0,
    "FacilityId": 0,
    "External_fee_id": '',
    "price_formatted": "",
    "Insurance": 0,
    "InsuranceValue": 0,
    "ScriptValue": "",
    "ExternalDealId": "",
    "Description": '',
    "PolicyNumber": '',
    "PolicyStartDate": dayjs(),
    "PolicyEndDate": dayjs().add(1, 'day'),
    "CoverageAmt": '',
    "quoted_rate": "15.00",
    "Otherproperitys": "",
    "ExternalPromotionId": "",
    "label": "New",
    "speedrent": false,
    "type": "",
    "merchandfee": "",
    "salestax": "",
    "TechFee": ""
}
interface MonthOption {
    label: string;
}
const RentAndReservationRent: React.FC<RentAndReservationRentProps> = ({ type }) => {
    // url params const variable
    const params = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const facilityId = params.facilityid;
    const FacilityId = Number(facilityId);
    const externalUnitIds = params.externalUnitId;
    const externalUnitId = Number(externalUnitIds);
    const firstNameInputRef = useRef<HTMLInputElement>(null);
    const isNonProduction = window.config.appEnv !== 'production';
    const { rentalData } = location.state || {};
    const promoId = type === 1 ? params?.promotionId : rentalData?.external_promotion_id;
    const dispatch = useAppDispatch();
    const { lookupActiveCall } = useLookupActiveAircallCall();
    const aircallLookupAttempted = useRef(false);
    // API calls
    const [getMoveInCost, { isLoading }] = useGetMoveInCostMutation();
    const [PostSpeedeRent] = usePostSpeedeRentMutation();
    const { data: protectionPlanData } = useGetProtectionPlanQuery(FacilityId);
    const { data: statesData } = useGetStatesQuery();
    const [merchandisedata, setMerchandisedata] = useState<merchandise[]>([]);
    // Transform the API response to match the format of { label: state name }
    const state = statesData?.states.map((state) => ({
        Id: state.abbreviation,
        label: state.name,
    })) || [];
    const {
        data: reservationDetails,
        refetch: refetchReservationDetails,
    } = useFetchReservationDetailsQuery(
        {
            facilityId: FacilityId,
            dealId: Number(rentalData.externalId),
        },
        {
            skip: isNaN(FacilityId) || isNaN(Number(rentalData.externalId)), // Ensure ExternalUnitId is checked if applicable
        }
    );
    const [patchReservationDetails] = usePatchReservationDetailsMutation();
    const { data: merchandise, refetch: refetchMerchandise } = useGetMerchandiseQuery(FacilityId ? (FacilityId) : 0);
    useEffect(() => {
        refetchMerchandise(); // Forces re-fetch when the component mounts
    }, []);

    useEffect(() => {
        if (aircallLookupAttempted.current) {
            return;
        }
        aircallLookupAttempted.current = true;
        void lookupActiveCall({
            successMessage:
                'The active Air Call call has been detected and the session call ID has been captured',
            showErrorToasts: false,
        });
    }, [lookupActiveCall]);

    const { data: availableUnitsData, isLoading: unitloading } = useGetAvailableUnitsDataQuery(
        !isNaN(FacilityId) ? FacilityId : 0,
        { skip: isNaN(FacilityId) }
    );
    const availableUnits = availableUnitsData?.available_units ?? [];

    //console.log("******rentalData", rentalData);
    //console.log("reservationDetails", reservationDetails);
    // controls Data Source
    const [errors, setErrors] = useState({
        "customerinfofirstname": false,
        "customerinfolastname": false,
        "customerinfoaddress1": false,
        "customerinfoaddress2": false,
        "customerinfocity": false,
        "customerinfoPostalcode": false,
        "customerinfophone": false,
        "customerinfoemail": false,
        "IdType": false,
        "IdTNumber": false,
        "IdIssuer": false,
        "emergencyContactfirstname": false,
        "emergencyContactlastname": false,
        "emergencyContactphone": false,
        "militaryStatusidnumber": false,
        "Description": false,
        "PolicyNumber": false,
        "PolicyStartDate": false,
        "PolicyEndDate": false,
        "CoverageAmt": false
    });
    // accorian logics
    const [expand, setExpand] = useState(
        {
            "Instructionsheader": false,
            "Insuranceheader": false,
            "Informationheader": false,
            "MoveIndetailsheader": false,
            "Verifyheader": true,
            "Paymentheader": false,
            "Merchandise": false,
        })
    const month: MonthOption[] = [
        { label: 'This Month' },
        { label: 'Next Month' },
        { label: 'No Promo' }
    ];
    const idType = [
        { Id: "dl", label: 'Drivers license', },
        { Id: "state", label: 'State ID', },
        { Id: "passport", label: 'International Passport', },
    ];
    const Status = [
        { Id: "1", label: 'Non-Military', },
        { Id: "2", label: 'Veteran', },
        { Id: "4", label: 'Active Duty', },
        { Id: "5", label: 'Reserve', },
    ]
    const branches = [
        { Id: "1", label: 'Air Force', },
        { Id: "2", label: 'Army', },
        { Id: "3", label: 'Coast Gaurd', },
        { Id: "4", label: 'Marine Cops', },
        { Id: "5", label: 'Navy', },
        { Id: "6", label: 'Space Force', },
    ]

    //  value formating functions
    const formatPhoneNumber = (phone: string): string => {
        const digits = phone.replace(/\D/g, '');
        if (digits.length !== 10) return 'Invalid Number';
        return digits.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
    };

    const formatPhoneToNational = (digits10: string): string =>
        digits10.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');

    const handlePhoneBlur = (e: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const name = e.target.name;
        if (name !== 'customerinfophone' && name !== 'emergencyContactphone') return;
        const raw = e.target.value;
        const digits = raw.replace(/\D/g, '');
        const isCustomer = name === 'customerinfophone';

        if (raw.trim() === '') {
            setrentData((prev) => ({ ...prev, [name]: '' }));
            setErrors((prev) => ({
                ...prev,
                [name]: isCustomer,
            }));
            return;
        }
        if (digits.length === 10) {
            setrentData((prev) => ({ ...prev, [name]: formatPhoneToNational(digits) }));
            setErrors((prev) => ({ ...prev, [name]: false }));
        } else {
            setErrors((prev) => ({ ...prev, [name]: true }));
        }
    };
    // format float value
    const formatQuotedRate = (quotedRate: string | number | null | undefined): number => {
        if (typeof quotedRate === 'number') {
            // If the value is already a number, ensure it has two decimals
            return parseFloat(quotedRate.toFixed(2));
        }

        if (typeof quotedRate === 'string') {
            // If it's a string, parse it into a float and ensure two decimals
            const floatValue = parseFloat(quotedRate);
            return isNaN(floatValue) ? 0.0 : parseFloat(floatValue.toFixed(2));
        }
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const CustomNoResultsOverlay = () => (
            <Box textAlign="center" p={2}>
                <Typography variant="h6">No Data Available</Typography>
            </Box>
        );

        // For null, undefined, or invalid input, return 0.00 as default
        return 0.0;
    };
    const getLastDayOfCurrentMonth = () => {
        return dayjs().endOf('month').format('YYYY-MM-DD'); // Format to desired string format
    };
    const removeHtmlTags = (text: string | null | undefined): string => {
        if (!text) {
            return ''; // Return an empty string for null or undefined input
        }
        // Decode HTML entities and normalize spaces
        const textArea = document.createElement('textarea');
        textArea.innerHTML = text;
        const decodedText = textArea.value.replace(/\s+/g, ' ').trim();

        return decodedText;
    };
    // Script read from the session storage
    const operatorsData = sessionStorage.getItem('operators');
    const FacilityData = sessionStorage.getItem('facilityData');
    const facilityDataObject = FacilityData ? JSON.parse(FacilityData) : null;
    const facilityscript = facilityDataObject[0]?.guides?.[0]?.create_reservation_script;
    const operators = operatorsData ? JSON.parse(operatorsData) : [];
    const script = facilityscript ? facilityscript : operators.operators[0]?.call_script;
    const operatorId = sessionStorage.getItem('operatorId');
    const { data: FacilityOperatorAlerts } = useGetOperatorGuidesQuery(operatorId ? parseInt(operatorId) : 0);
    const OperatorAlert = FacilityOperatorAlerts?.guides || [];
    const insurencenotes = facilityDataObject[0]?.guides?.[0]?.insurance_notes;
    const moveininstruction = facilityDataObject[0]?.guides?.[0]?.movein_instruction;
    const protectionplans = facilityDataObject[0]?.protection_plans
    const promotionsData = facilityDataObject[0]?.promotions
    const isTestFacility = facilityDataObject[0]?.is_test === 1;
    const prodectionplan = protectionPlanData?.protection_plans || [];
    const storedTimezone = sessionStorage.getItem('timezoneName') || 'UTC'; // Retrieve timezone dynamically
    const validTimezone = timezoneMapping[storedTimezone] || storedTimezone;
    const todaydate = dayjs();
    const SettingData = sessionStorage.getItem('setting');
    const Settings = SettingData ? JSON.parse(SettingData) : [];
    const maximumSelectableDate = Settings.rent_lead_time_days;

    //Use state variables declaration
    const [ispeedloading, setispeedloading] = useState(false);
    const [selectedMonth, setSelectedMonth] = useState<MonthOption>(month[0]);
    const [rentData, setrentData] = useState<typeof rentapi>(rentapi);
    const [selectinsurence, setinsurance] = useState("");
    const [is_promo_deferred, setis_promo_deferred] = useState(false);
    const [productionExternalid, setproductionExternalid] = useState<string | null>("");
    const [isOtherChecked, setIsOtherChecked] = useState<boolean>(false);
    const [checkedItems, setCheckedItems] = useState<string[]>([]);
    const [selectedPremium, setSelectedPremium] = useState(0);
    const [periods, setPeriods] = useState<number>(0);
    const [periodsValidationError, setPeriodsValidationError] = useState(false);
    const [expandedRecurringPeriods, setExpandedRecurringPeriods] = useState<Record<string, boolean>>({});
    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const [cost, setCost] = useState<MoveInCosts | null>(null);
    /** Move-in cost for periods=0 only — Transaction Details / payment amounts stay stable when Payment Periods changes. */
    const [transactionDetailsCost, setTransactionDetailsCost] = useState<MoveInCosts | null>(null);
    const [Islookup, setIslookup] = useState(false);
    const [gridData, setGridData] = useState<OccupancyData[]>([]);
    const [isgrid, setIsgrid] = useState(false);
    const [Movindate, setMovindate] = useState("");
    const [minDate, setMinDate] = useState(dayjs());
    const [maxDate, setMaxDate] = useState(dayjs());
    const [selectedmerchandise, setselectedMerchandise] = useState<Merchandiseparams[] | null>(null);
    const [selectedUnit, setSelectedUnit] = useState<string | null>(() =>
        rentalData?.externalUnitId != null && rentalData.externalUnitId !== ''
            ? String(rentalData.externalUnitId)
            : rentalData?.external_unit_id != null
              ? String(rentalData.external_unit_id)
              : params?.externalUnitId != null
                ? String(params.externalUnitId)
                : null
    );
    /** PATCH deal + move-in-cost after unit dropdown change (reservation flow) */
    const [isDealUnitUpdateInProgress, setIsDealUnitUpdateInProgress] = useState(false);
    const moveInCostDebugRef = useRef({
        seq: 0,
        inFlight: false,
        lastRequestKey: '',
        lastStartedAt: 0,
    });
    const [searchdata, setSearchdata] = useState({
        firstnamesearch: '',
        lastnamesearch: '',
        accesscodesearch: '',
        emailsearch: '',
        phonesearch: '',
    });
    const [ispromo, setispromo] = useState(Number);
    const monthlyRent = Number(rentalData?.price_formatted) || 0;
    const monthlyRentreser = reservationDetails?.deal?.quoted_price || 0.00;
    const insuranceCost = Number(selectedPremium) || 0;
    const monthlyCost = type === 1 ? monthlyRent + insuranceCost : monthlyRentreser + insuranceCost;

    // Click events
    const handleAccordionClick = (headerToToggle: string) => {
        setExpand((prevState) => ({
            ...prevState,
            [headerToToggle as keyof typeof prevState]: !prevState[headerToToggle as keyof typeof prevState],
        }));
    };
    const handleDialogClose = () => {
        setIsDialogOpen(false);
        navigate(`/Dashboard/${facilityId}`); // Correct string interpolation
    };
    const handleSubmit = async () => {
        if (noOthersAvailableType2) {
            AircallNofity({ type: 'error', Msg: 'The original unit has been rented. There are no more available units in this group. Please return to the Facility Page, manage deal and select a new available unit.' });
            return;
        }
        setExpand({
            Verifyheader: false,
            Instructionsheader: false,
            Informationheader: true,
            Insuranceheader: false,
            MoveIndetailsheader: false,
            Paymentheader: false,
            Merchandise: false,
        });
    };
    // next button onclick
    const handleNext = (headerToExpand: string) => {
        setExpand({
            Verifyheader: headerToExpand === 'Verifyheader',
            Instructionsheader: headerToExpand === 'Instructionsheader',
            Insuranceheader: headerToExpand === 'Insuranceheader',
            Informationheader: headerToExpand === 'Informationheader',
            MoveIndetailsheader: headerToExpand === 'MoveIndetailsheader',
            Paymentheader: headerToExpand === 'Paymentheader',
            Merchandise: headerToExpand === 'Merchandise',
        });
    }

    const handleDateChange = (newValue: Dayjs | null) => {
        if (newValue) {
            const formattedDate = newValue.format('YYYY-MM-DD');
            const resolvedExternalUnitId =
                selectedUnit != null && selectedUnit !== ''
                    ? Number(selectedUnit)
                    : rentData.ExternalUnitId || rentalData.external_unit_id || '';
            setrentData({
                ...rentData,
                start_date: formattedDate,
                ExternalUnitId: resolvedExternalUnitId,
                promoid: rentalData?.external_promotion_id || '',
                PromotionStart: formattedDate
            });

            // Set move-in date as an ISO string without time (just date in UTC format)
            setMovindate(`${formattedDate}T00:00:00.000Z`);
        }
    };
    // merchandise data bind
    useEffect(() => {
        if (merchandise) {
            const updated = merchandise.map(item => ({
                ...item,
                quantity: 0,
                remaining: Number(item.in_stock),
            }));

            setMerchandisedata(updated);
        }
    }, [merchandise]);
    // unit data binding

    // Find matching unit type from available_units (width, length, product_type, inside, drive_up, climate, air_cooled, heated, elevator, stair_access, price)
    const findMatchingUnitType = (
        width?: number,
        length?: number,
        productTypeId?: string | number,
        inside?: number,
        driveUp?: number,
        climate?: number,
        airCooled?: number,
        heated?: number,
        elevator?: number,
        stairAccess?: number,
        price?: number
    ) =>
        availableUnits.find((u) => {
            const wMatch = Number(u.width ?? 0) === Number(width ?? 0);
            const lMatch = Number(u.length ?? 0) === Number(length ?? 0);
            const typeMatch = String(u.external_type_id ?? '') === String(productTypeId ?? '');
            const insideMatch = Number(u.inside ?? 0) === Number(inside ?? 0);
            // Skip when deal/rentalData doesn't have the value (e.g. legacy units, missing unitType)
            const driveUpMatch = driveUp === undefined ? true : Number(u.drive_up ?? 0) === Number(driveUp ?? 0);
            const climateMatch = Number(u.climate ?? 0) === Number(climate ?? 0);
            const airCooledMatch = airCooled === undefined ? true : Number(u.air_cooled ?? 0) === Number(airCooled ?? 0);
            const heatedMatch = heated === undefined ? true : Number(u.heated ?? 0) === Number(heated ?? 0);
            const elevatorMatch = elevator === undefined ? true : Number(u.elevator ?? 0) === Number(elevator ?? 0);
            const stairAccessMatch = stairAccess === undefined ? true : Number(u.stair_access ?? 0) === Number(stairAccess ?? 0);
            const priceMatch = Math.abs(Number(u.price ?? 0) - Number(price ?? 0)) < 0.01;
            return wMatch && lMatch && typeMatch && insideMatch && driveUpMatch && climateMatch && airCooledMatch && heatedMatch && elevatorMatch && stairAccessMatch && priceMatch;
        });

    // Find matching unit type without price (width, length, product_type, inside, drive_up, climate, air_cooled, heated, elevator, stair_access only) - for price-changed scenario
    const findMatchingUnitTypeWithoutPrice = (
        width?: number,
        length?: number,
        productTypeId?: string | number,
        inside?: number,
        driveUp?: number,
        climate?: number,
        airCooled?: number,
        heated?: number,
        elevator?: number,
        stairAccess?: number
    ) =>
        availableUnits.find((u) => {
            const wMatch = Number(u.width ?? 0) === Number(width ?? 0);
            const lMatch = Number(u.length ?? 0) === Number(length ?? 0);
            const typeMatch = String(u.external_type_id ?? '') === String(productTypeId ?? '');
            const insideMatch = Number(u.inside ?? 0) === Number(inside ?? 0);
            const driveUpMatch = driveUp === undefined ? true : Number(u.drive_up ?? 0) === Number(driveUp ?? 0);
            const climateMatch = Number(u.climate ?? 0) === Number(climate ?? 0);
            const airCooledMatch = airCooled === undefined ? true : Number(u.air_cooled ?? 0) === Number(airCooled ?? 0);
            const heatedMatch = heated === undefined ? true : Number(u.heated ?? 0) === Number(heated ?? 0);
            const elevatorMatch = elevator === undefined ? true : Number(u.elevator ?? 0) === Number(elevator ?? 0);
            const stairAccessMatch = stairAccess === undefined ? true : Number(u.stair_access ?? 0) === Number(stairAccess ?? 0);
            return wMatch && lMatch && typeMatch && insideMatch && driveUpMatch && climateMatch && airCooledMatch && heatedMatch && elevatorMatch && stairAccessMatch;
        });

    // Unit options: type 1 uses rentalData.units or match from available_units; type 2 uses match from available_units
    const matchingUnitType1ByAttrs =
        rentalData?.width != null || rentalData?.external_typeId != null
            ? findMatchingUnitType(
                  rentalData?.width,
                  rentalData?.length,
                  rentalData?.external_typeId,
                  rentalData?.inside ?? 0,
                  rentalData?.drive_up,
                  rentalData?.climate ?? 0,
                  rentalData?.air_cooled,
                  rentalData?.heated,
                  rentalData?.elevator,
                  rentalData?.stair_access,
                  parseFloat(String(rentalData?.rent ?? 0).replace(/[$,]/g, ''))
              )
            : undefined;
    // Resolve unit-type group by URL/selected unit id (works on refresh when location.state is lost)
    const type1UnitId =
        selectedUnit ??
        (params?.externalUnitId != null ? String(params.externalUnitId) : null) ??
        (rentalData?.externalUnitId != null ? String(rentalData.externalUnitId) : null);
    const matchingUnitType1ByUnitId =
        type1UnitId != null
            ? availableUnits.find(
                  (u) =>
                      String(u.external_unit_id ?? '') === type1UnitId ||
                      (u.units ?? []).some((unit) => String(unit.id) === type1UnitId)
              )
            : undefined;
    const matchingUnitType1 = matchingUnitType1ByAttrs ?? matchingUnitType1ByUnitId;
    const unitOptionsType1 =
        (rentalData?.units?.length ?? 0) > 0
            ? rentalData.units.map((u: { id: number; unit_number: string }) => ({
                  external_id: u.id.toString(),
                  unit_number: u.unit_number,
              }))
            : (matchingUnitType1?.units ?? []).map((u: { id: number; unit_number: string }) => ({
                  external_id: u.id.toString(),
                  unit_number: u.unit_number,
              }));

    const matchParamsType2 = {
        width: reservationDetails?.deal?.unit?.width,
        length: reservationDetails?.deal?.unit?.length,
        productTypeId: reservationDetails?.deal?.unit?.external_unit_type_id,
        inside: reservationDetails?.deal?.unit?.is_inside ?? 0,
        driveUp: reservationDetails?.deal?.unit?.is_drive_up,
        climate: reservationDetails?.deal?.unit?.is_climate ?? 0,
        airCooled: reservationDetails?.deal?.unit?.is_air_cooled,
        heated: reservationDetails?.deal?.unit?.is_heated,
        elevator: reservationDetails?.deal?.unit?.is_elevator,
        stairAccess: reservationDetails?.deal?.unit?.is_stair_access,
        price: reservationDetails?.deal?.quoted_price ?? 0,
    };
    const matchingUnitType2Exact = findMatchingUnitType(
        matchParamsType2.width,
        matchParamsType2.length,
        matchParamsType2.productTypeId,
        matchParamsType2.inside,
        matchParamsType2.driveUp,
        matchParamsType2.climate,
        matchParamsType2.airCooled,
        matchParamsType2.heated,
        matchParamsType2.elevator,
        matchParamsType2.stairAccess,
        matchParamsType2.price
    );
    const matchingUnitType2WithoutPrice = findMatchingUnitTypeWithoutPrice(
        matchParamsType2.width,
        matchParamsType2.length,
        matchParamsType2.productTypeId,
        matchParamsType2.inside,
        matchParamsType2.driveUp,
        matchParamsType2.climate,
        matchParamsType2.airCooled,
        matchParamsType2.heated,
        matchParamsType2.elevator,
        matchParamsType2.stairAccess
    );
    // Use exact match if found; otherwise use match without price (dimensions/type same, price different)
    const matchingUnitType2 = matchingUnitType2Exact ?? matchingUnitType2WithoutPrice;
    const unitOptionsType2 =
        matchingUnitType2?.units?.length
            ? matchingUnitType2.units.map((u: { id: number; unit_number: string }) => ({
                  external_id: u.id.toString(),
                  unit_number: u.unit_number,
              }))
            : [];

    const unitOptions = type === 1 ? unitOptionsType1 : unitOptionsType2;
    // Prefer matched unit-type-price-list row (authoritative); fall back to rental session. Only false disables insurance.
    const resolvedIsInsurable =
        type === 1
            ? (matchingUnitType1?.is_insurable ?? rentalData?.is_insurable)
            : (matchingUnitType2?.is_insurable ?? rentalData?.is_insurable);
    // null/undefined → keep prior behavior (show insurance); only explicit false/0 hides it
    const isInsurable = resolvedIsInsurable == null ? true : !!resolvedIsInsurable;
    const hasNoMatchType2 =
        type === 2 &&
        reservationDetails?.deal?.unit != null &&
        availableUnitsData != null &&
        !matchingUnitType2;

    // Unit type exists but deal's unit number is not in the units array (e.g. unit was rented)
    const dealUnitIdType2 = reservationDetails?.deal?.external_unit_id;
    const unitNotInUnitsArrayType2 =
        type === 2 &&
        matchingUnitType2 != null &&
        (matchingUnitType2.units?.length ?? 0) > 0 &&
        dealUnitIdType2 != null &&
        dealUnitIdType2 !== '' &&
        !matchingUnitType2.units.some((u: { id: number }) => String(u.id) === String(dealUnitIdType2));

    // Scenario 1 (price change only): no snackbar per spec
    const hasShownNoMatchSnackbar = useRef(false);
    const dealUnitReplacementPatchRef = useRef(false);
    /** While true, skip useEffect move-in-cost so handleUnitChange can PATCH deal then call move-in-cost in order. */
    const deferMoveInCostForUnitPatchRef = useRef(false);
    // Scenario 2/4: unit rented, others available; Scenario 3/5: unit rented, no others available
    const othersAvailableType2 = unitNotInUnitsArrayType2 && unitOptionsType2.length > 0;
    const noOthersAvailableType2 = hasNoMatchType2 || (unitNotInUnitsArrayType2 && unitOptionsType2.length === 0);
    useEffect(() => {
        const showUnitUnavailable = (hasNoMatchType2 || unitNotInUnitsArrayType2) && !hasShownNoMatchSnackbar.current;
        if (showUnitUnavailable) {
            hasShownNoMatchSnackbar.current = true;
            const msg = othersAvailableType2
                ? 'The unit is no longer available. The system has auto-selected the next available unit in the price group.'
                : 'The original unit has been rented. There are no more available units in this group. Please return to the Facility Page, manage deal and select a new available unit.';
            AircallNofity({
                type: othersAvailableType2 ? 'info' : 'error',
                Msg: msg,
            });
        }
    }, [hasNoMatchType2, unitNotInUnitsArrayType2, othersAvailableType2]);

    // Scenario 2/4: Deal unit not in unit-type-price list — auto-select first available unit, PATCH deal, refetch
    useEffect(() => {
        if (type !== 2 || !unitNotInUnitsArrayType2 || unitOptionsType2.length === 0 || !reservationDetails?.deal) {
            return;
        }
        const firstOption = unitOptionsType2[0];
        const newUnitId = String(firstOption.external_id);
        const deal = reservationDetails.deal;

        if (String(selectedUnit) !== newUnitId) {
            setSelectedUnit(newUnitId);
            setrentData((prev) => ({ ...prev, ExternalUnitId: Number(newUnitId) }));
        }

        if (String(deal.external_unit_id) === newUnitId) {
            return;
        }
        if (dealUnitReplacementPatchRef.current) {
            return;
        }
        dealUnitReplacementPatchRef.current = true;

        const agentName =
            (sessionStorage.getItem('FirstName') || '') + ' ' + (sessionStorage.getItem('LastName') || '');
        const followupFromDeal = dayjs(deal.followup_at);
        const followupDateStr = followupFromDeal.isValid()
            ? followupFromDeal.format('YYYY-MM-DD')
            : dayjs().add(5, 'day').format('YYYY-MM-DD');
        const moveInFromDeal = dayjs(deal.move_in_date);
        const moveInDateStr =
            moveInFromDeal.isValid() && !moveInFromDeal.isBefore(dayjs(), 'day')
                ? moveInFromDeal.format('YYYY-MM-DD')
                : dayjs().format('YYYY-MM-DD');
        const body: UpdateReservationDetails = {
            first_name: deal.first_name,
            last_name: deal.last_name,
            email: deal.email,
            phone: deal.phone,
            quoted_rate: deal.quoted_price ?? 0,
            type: deal.type ?? 'N/A',
            move_in_date: moveInDateStr,
            followup_date: followupDateStr,
            external_unit_id: newUnitId,
            external_promotion_id: deal.external_promotion_id,
            external_product_type_id: String(deal.unit?.external_unit_type_id ?? ''),
            status: deal.status ?? 'N/A',
        };

        deferMoveInCostForUnitPatchRef.current = true;
        setIsDealUnitUpdateInProgress(true);

        (async () => {
            try {
                await patchReservationDetails({
                    facilityId: FacilityId,
                    dealId: Number(rentalData.externalId),
                    body: { ...body, agent: agentName } as UpdateReservationDetails & { agent: string },
                }).unwrap();
                await refetchReservationDetails();
                AircallNofity({
                    type: 'success',
                    Msg: 'Deal has been updated to have a new unit number.',
                });
            } catch (e) {
                console.error('Failed to update deal unit to available unit:', e);
                dealUnitReplacementPatchRef.current = false;
                AircallNofity({
                    type: 'error',
                    Msg: 'Could not update the deal to the replacement unit. Move-in costs may be wrong until you try again.',
                });
            } finally {
                deferMoveInCostForUnitPatchRef.current = false;
                setIsDealUnitUpdateInProgress(false);
            }
        })();
    }, [
        type,
        unitNotInUnitsArrayType2,
        unitOptionsType2,
        reservationDetails,
        FacilityId,
        rentalData.externalId,
        patchReservationDetails,
        refetchReservationDetails,
    ]);

    // reservation function calling

    useEffect(() => {
        if (facilityId) {
            if (reservationDetails)
                reservationdetails();
        }
    }, [reservationDetails])// eslint-disable-line react-hooks/exhaustive-deps
    const formatPrice = (value: number | string | undefined): string => {
        return `$${parseFloat((value || "0").toString()).toFixed(2)}`;
    };

    const toAmount = (value: unknown): number => {
        if (typeof value === 'number') return Number.isFinite(value) ? value : 0;
        if (typeof value === 'string') {
            const cleaned = value.replace(/[^0-9.-]/g, '');
            const parsed = parseFloat(cleaned);
            return Number.isFinite(parsed) ? parsed : 0;
        }
        return 0;
    };

    const formatCurrency = (value: number): string => `$${toAmount(value).toFixed(2)}`;

    const buildRecurringPeriodsFromCostSource = React.useCallback((costSource: MoveInCosts | null): RecurringPeriodItem[] => {
        if (!costSource) return [];

        const formatRecurringDate = (rawDate: unknown, index: number): string => {
            if (typeof rawDate === 'string') {
                const datePart = rawDate.split('T')[0];
                const dateMatch = /^(\d{4})-(\d{2})-(\d{2})$/.exec(datePart);
                if (dateMatch) {
                    const [, year, month, day] = dateMatch;
                    return `${Number(month)}/${Number(day)}/${year}`;
                }
            }

            const baseDate =
                (typeof rentData.start_date === 'string' && dayjs(rentData.start_date).isValid())
                    ? dayjs(rentData.start_date)
                    : (typeof Movindate === 'string' && dayjs(Movindate).isValid())
                        ? dayjs(Movindate)
                        : dayjs();

            return baseDate.add(index, 'month').startOf('month').format('M/D/YYYY');
        };

        const normalizeRecurringPeriod = (raw: Record<string, any>, index: number): RecurringPeriodItem => {
            const rent = toAmount(raw.rent ?? raw.rent_subtotal ?? raw.rent_total);
            const promotion = toAmount(
                raw.promo_adjustments ??
                raw.promotion_adjustment ??
                raw.next_payment_promo_adjustments
            );
            const insurance =
                toAmount(raw.tpp_total) ||
                (toAmount(raw.tpp) + toAmount(raw.tpp_tax)) ||
                (toAmount(raw.tpp_plan?.cost) + toAmount(raw.tpp_plan?.tax)) ||
                (toAmount(raw.next_payment_tpp_plan?.cost) + toAmount(raw.next_payment_tpp_plan?.tax));
            const fees = toAmount(raw.fees_total ?? raw.fee_total ?? raw.fees_subtotal ?? raw.next_payment_fees_total);
            const tax = toAmount(raw.rent_tax ?? raw.next_payment_tax_amount ?? raw.tax);
            const total =
                toAmount(raw.total ?? raw.grand_total ?? raw.next_payment) ||
                Math.max(0, rent + insurance + fees + tax - promotion);

            return {
                key: `${index}-${String(raw.date ?? raw.next_payment_date ?? raw.period_start_date ?? raw.next_billing_date ?? '')}`,
                title: formatRecurringDate(
                    raw.date ?? raw.next_payment_date ?? raw.period_start_date ?? raw.next_billing_date,
                    index
                ),
                rent,
                promotion,
                insurance,
                fees,
                tax,
                total,
            };
        };

        const data = costSource as MoveInCosts & Record<string, any>;
        const chargesDueToday = Array.isArray(data.charges_due_today) ? data.charges_due_today : [];
        if (chargesDueToday.length > 0) {
            const grouped = new Map<string, {
                dueAt: string;
                rent: number;
                promotion: number;
                insurance: number;
                fees: number;
                tax: number;
                total: number;
            }>();

            chargesDueToday.forEach((charge: Record<string, any>) => {
                const dueAt = String(charge?.due_at ?? '');
                if (!dueAt) return;
                const typeId = String(charge?.type_id ?? '').toUpperCase();
                if (typeId !== 'RENT' && typeId !== 'TPP' && typeId !== 'FEE') {
                    return;
                }

                const current = grouped.get(dueAt) ?? {
                    dueAt,
                    rent: 0,
                    promotion: 0,
                    insurance: 0,
                    fees: 0,
                    tax: 0,
                    total: 0,
                };

                const chargeAmount = toAmount(charge?.owed_amount);
                const chargeTax = toAmount(charge?.owed_tax);
                const chargeTotal = toAmount(charge?.owed_total);

                // Recurring Monthly Cost should represent recurring charges only.
                if (typeId === 'RENT') {
                    current.rent += chargeAmount;
                    current.tax += chargeTax;
                    current.total += chargeTotal;
                } else if (typeId === 'TPP') {
                    current.insurance += chargeAmount;
                    current.tax += chargeTax;
                    current.total += chargeTotal;
                } else if (typeId === 'FEE') {
                    current.fees += chargeAmount;
                    current.tax += chargeTax;
                    current.total += chargeTotal;
                }

                const activities = Array.isArray(charge?.activities) ? charge.activities : [];
                activities.forEach((activity: Record<string, any>) => {
                    const activityTypeId = String(activity?.type_id ?? '').toUpperCase();
                    const isDecrease = Boolean(activity?.is_decrease);
                    if (activityTypeId === 'PROMO' && isDecrease) {
                        current.promotion += toAmount(activity?.total ?? activity?.subtotal);
                    }
                });

                grouped.set(dueAt, current);
            });

            return Array.from(grouped.values())
                .sort((a, b) => {
                    const aDate = String(a.dueAt).split('T')[0];
                    const bDate = String(b.dueAt).split('T')[0];
                    return aDate.localeCompare(bDate);
                })
                .map((group, index) => ({
                    key: `${index}-${group.dueAt}`,
                    title: formatRecurringDate(group.dueAt, index),
                    rent: group.rent,
                    promotion: group.promotion,
                    insurance: group.insurance,
                    fees: group.fees,
                    tax: group.tax,
                    total: Math.max(0, group.total),
                }));
        }

        const periodsFromApi = Array.isArray(data.periods) ? data.periods : [];
        if (periodsFromApi.length > 0) {
            return periodsFromApi.map((period, index) => normalizeRecurringPeriod(period ?? {}, index));
        }

        const additionalPeriods = Array.isArray(data.additional_periods) ? data.additional_periods : [];
        if (additionalPeriods.length > 0 || data.next_payment || data.next_payment_date) {
            const firstNextPeriod = {
                date: data.next_payment_date,
                next_payment: data.next_payment,
                next_payment_promo_adjustments: data.next_payment_promo_adjustments,
                next_payment_tax_amount: data.next_payment_tax_amount,
                next_payment_tpp_plan: data.next_payment_tpp_plan,
                next_payment_fees: data.next_payment_fees,
                rent: data.rent,
                tpp: data.tpp,
                tpp_tax: data.tpp_tax,
                tax: data.tax,
            };

            return [firstNextPeriod, ...additionalPeriods].map((period, index) =>
                normalizeRecurringPeriod(period ?? {}, index)
            );
        }

        return [
            normalizeRecurringPeriod(
                {
                    date: data.rent_end_date ? dayjs(data.rent_end_date).add(1, 'day').format('YYYY-MM-DD') : rentData.start_date,
                    rent: type === 1 ? rentalData?.price_formatted : reservationDetails?.deal?.quoted_price,
                    promo_adjustments: 0,
                    tpp: data.tpp ?? selectedPremium,
                    tpp_tax: data.tpp_tax ?? 0,
                    rent_tax: data.rent_tax ?? 0,
                    total: Number(monthlyCost) || 0,
                },
                0
            ),
        ];
    }, [monthlyCost, Movindate, rentData.start_date, rentalData?.price_formatted, reservationDetails?.deal?.quoted_price, selectedPremium, type]);

    const recurringPeriodsData = React.useMemo(
        () => buildRecurringPeriodsFromCostSource(cost),
        [buildRecurringPeriodsFromCostSource, cost]
    );
    const transactionDetailsPeriodsData = React.useMemo(
        () => buildRecurringPeriodsFromCostSource(transactionDetailsCost),
        [buildRecurringPeriodsFromCostSource, transactionDetailsCost]
    );

    const handleToggleRecurringPeriod = (key: string) => {
        setExpandedRecurringPeriods((prev) => ({
            ...prev,
            [key]: !(prev[key] ?? true),
        }));
    };

    const handlePeriodsChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const rawValue = event.target.value;
        const parsed = parseInt(rawValue, 10);
        const nextValue = Number.isFinite(parsed) ? Math.min(11, Math.max(0, parsed)) : 0;
        setPeriods(nextValue);
        setPeriodsValidationError((prev) => (nextValue === 0 ? false : prev));
    };
    const incrementPeriods = () => {
        setPeriods((prev) => Math.min(11, prev + 1));
    };
    const decrementPeriods = () => {
        setPeriods((prev) => {
            const nextValue = Math.max(0, prev - 1);
            if (nextValue === 0) {
                setPeriodsValidationError(false);
            }
            return nextValue;
        });
    };
    const periodsFieldHasError = periodsValidationError && periods > 0;
    const periodsFieldSx = {
        width: 56,
        '& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline': {
            borderColor: 'error.main',
            borderWidth: 2,
        },
        '& .MuiInputBase-input': {
            textAlign: 'center',
            paddingLeft: '6px',
            paddingRight: '6px',
        },
    };

    <TableCell align="right">
        <Typography>
            {type === 1
                ? formatPrice(rentalData?.price_formatted)
                : formatPrice(reservationDetails?.deal?.quoted_price)}
        </Typography>
    </TableCell>

    // reservation details data fetch

    const reservationdetails = async () => {
        if (type === 2) {
            const occupantdetails = reservationDetails?.deal.occupant;
            const Unit = reservationDetails?.deal.unit;
            const date = reservationDetails?.deal?.move_in_date || ""
            const dateToSet = dayjs(date).isBefore(todaydate)
                ? dayjs(todaydate).format("YYYY-MM-DD")
                : dayjs(date || todaydate).format("YYYY-MM-DD");
            setMovindate(dateToSet);
            setrentData({
                ...rentData,
                promoid: rentalData?.external_promotion_id?.toString() || null,
                customerinfofirstname: reservationDetails?.deal?.first_name || "",
                customerinfolastname: reservationDetails?.deal?.last_name || "",
                customerinfoemail: reservationDetails?.deal?.email || "",
                customerinfoaddress1: reservationDetails?.deal?.occupant?.address || reservationDetails?.deal?.address || "",
                customerinfoaddress2: reservationDetails?.deal?.occupant?.address2 || reservationDetails?.deal?.address2 || "",
                customerinfocity: reservationDetails?.deal?.occupant?.city || reservationDetails?.deal?.city || "",
                customerinfostate: reservationDetails?.deal?.occupant?.state || reservationDetails?.deal?.state || "",
                customerinfoPostalcode: reservationDetails?.deal?.occupant?.postal_code || reservationDetails?.deal?.postal_code || "",
                customerinfophone: formatPhoneNumber(reservationDetails?.deal?.phone || ""),
                UnitSize: reservationDetails?.deal?.unit_dimensions || "",
                Features: `${Unit?.is_climate === 1 ? 'Climate' : 'Inside'}${Unit?.floor === 1 ? ', First Floor' : ''}`,
                MonthlyRate: reservationDetails?.deal?.quoted_price?.toString() || "",
                occupancyid: reservationDetails?.deal?.external_occupant_id?.toString() || "",
                start_date: dayjs(date).isBefore(todaydate)
                    ? todaydate.toString()
                    : date?.toString() || todaydate.toString(),
                quoted_rate: reservationDetails?.deal?.quoted_price?.toString() || "",
                type: reservationDetails?.deal?.type || "",
                label: rentalData?.label || "Update"

            });
            if (occupantdetails && reservationDetails?.deal.external_occupant_id) {
                setrentData(prevData => ({
                    ...prevData,

                    IdType: occupantdetails.id_type || "",
                    IdTNumber: occupantdetails.id_number || "",
                    IdIssuer: occupantdetails.id_state || "",
                    militaryStatus: occupantdetails.military_status?.toString() || "",
                    militaryStatusbranch: occupantdetails.military_branch?.toString() || "",
                    militaryStatusidnumber: occupantdetails.military_id || "",
                }));
            }
        }
        else {
            setrentData({
                ...rentData,
                promoid: params?.promotionId ? params?.promotionId : "",
            })
        }

    }
    // unit handle change — reservation flow: PATCH deal, then move-in-cost (sequence; useEffect skipped meanwhile)
    const handleUnitChange = async (
        _event: React.SyntheticEvent,
        value: { external_id: string; unit_number: string } | null
    ) => {
        const willPatchDealWithNewUnit =
            type === 2 &&
            rentalData?.externalId != null &&
            reservationDetails?.deal != null &&
            value?.external_id != null &&
            String(reservationDetails.deal.external_unit_id) !== String(value.external_id);

        if (willPatchDealWithNewUnit) {
            deferMoveInCostForUnitPatchRef.current = true;
        }

        setSelectedUnit(value ? value.external_id : null);
        setrentData((rentData) => ({
            ...rentData,
            ExternalUnitId: value?.external_id != null ? Number(value.external_id) : rentData.ExternalUnitId,
        }));

        if (type !== 2 || !rentalData?.externalId || !reservationDetails?.deal) {
            return;
        }
        if (!value?.external_id) {
            return;
        }
        const deal = reservationDetails.deal;
        const newUnitId = String(value.external_id);
        if (String(deal.external_unit_id) === newUnitId) {
            return;
        }

        const agentName =
            (sessionStorage.getItem('FirstName') || '') + ' ' + (sessionStorage.getItem('LastName') || '');
        const followupFromDeal = dayjs(deal.followup_at);
        const followupDateStr = followupFromDeal.isValid()
            ? followupFromDeal.format('YYYY-MM-DD')
            : dayjs().add(5, 'day').format('YYYY-MM-DD');
        const moveInFromDeal = dayjs(deal.move_in_date);
        const moveInDateStr =
            moveInFromDeal.isValid() && !moveInFromDeal.isBefore(dayjs(), 'day')
                ? moveInFromDeal.format('YYYY-MM-DD')
                : dayjs().format('YYYY-MM-DD');
        const body: UpdateReservationDetails = {
            first_name: deal.first_name,
            last_name: deal.last_name,
            email: deal.email,
            phone: deal.phone,
            quoted_rate: deal.quoted_price ?? 0,
            type: deal.type ?? 'N/A',
            move_in_date: moveInDateStr,
            followup_date: followupDateStr,
            external_unit_id: newUnitId,
            external_promotion_id: deal.external_promotion_id,
            external_product_type_id: String(deal.unit?.external_unit_type_id ?? ''),
            status: deal.status ?? 'N/A',
        };

        setIsDealUnitUpdateInProgress(true);
        try {
            await patchReservationDetails({
                facilityId: FacilityId,
                dealId: Number(rentalData.externalId),
                body: { ...body, agent: agentName } as UpdateReservationDetails & { agent: string },
            }).unwrap();
            await refetchReservationDetails();
            deferMoveInCostForUnitPatchRef.current = false;
            AircallNofity({ type: 'success', Msg: 'Deal updated with the new unit.' });
        } catch (e) {
            deferMoveInCostForUnitPatchRef.current = false;
            console.error('Failed to PATCH deal with new unit:', e);
            const msg = getApiErrorMessage(e) ?? 'Could not update the deal with the selected unit.';
            AircallNofity({ type: 'error', Msg: msg });
        } finally {
            setIsDealUnitUpdateInProgress(false);
        }
    };

    // Keep is_insurable on rent session data for move-in / speederent payloads
    useEffect(() => {
        setrentData((prevData) => ({
            ...prevData,
            is_insurable: isInsurable,
        }));
    }, [isInsurable]);

    // defult prodection plan setting
    useEffect(() => {
        let guaranteedValue = 0;

        if (promotionsData && promotionsData.length > 0) {
            const promotion = promotionsData.find(
                (promo: { external_id: string }) =>
                    promo.external_id === promoId
            );

            if (promotion && 'is_guaranteed_value' in promotion) {
                guaranteedValue = promotion.is_guaranteed_value;
            }
            setispromo(guaranteedValue);
        }

        if (!isInsurable) {
            setinsurance("");
            setproductionExternalid(null);
            setSelectedPremium(0);
            setrentData((prevData) => ({
                ...prevData,
                selectinsurence: "",
                prodection_external_id: "",
                promoname: "",
                promoprice: "",
                is_insurable: false,
            }));
            return;
        }

        if (!protectionplans || protectionplans.length === 0) {
            console.warn("No protection plans available.");
            return;
        }
        const autoEnrollPlan = protectionplans.find(
            (plan: { is_auto_enroll: number }) => plan.is_auto_enroll === 1
        );
        const defaultPlan = autoEnrollPlan
            ? autoEnrollPlan
            : protectionplans.reduce(
                (lowest: { coverage: number; }, current: { coverage: number; }) => (current.coverage < lowest.coverage ? current : lowest),
                protectionplans[0]
            );
        setinsurance(defaultPlan.id.toString());
        setproductionExternalid(defaultPlan.external_id);
        setSelectedPremium(defaultPlan.premium);
        setrentData((prevData) => ({
            ...prevData,
            prodection_external_id: defaultPlan.external_id,
            promoname: defaultPlan.name || "",
            promoprice: defaultPlan.coverage.toString(),
            promoid: params?.promotionId ? params?.promotionId : "",
            is_insurable: true,
        }));
    }, [prodectionplan, isInsurable]);

    // Movin api calling
    useEffect(() => {
        const isType2Ready =
            type !== 2 ||
            (
                !!reservationDetails?.deal &&
                !unitloading &&
                !!Movindate &&
                (
                    !!selectedUnit ||
                    (rentData.ExternalUnitId != null && Number(rentData.ExternalUnitId) !== 0) ||
                    (rentalData?.externalUnitId != null && rentalData.externalUnitId !== '')
                )
            );

        const effectSnapshot = {
            productionExternalid,
            isDealUnitUpdateInProgress,
            deferMoveInCost: deferMoveInCostForUnitPatchRef.current,
            type,
            Movindate,
            selectedUnit,
            isType2Ready,
            unitloading,
            unitNotInUnitsArrayType2,
            selectedMonth: selectedMonth?.label ?? null,
            periods,
            merchandiseCount: merchandisedata?.filter((m) => m.quantity !== 0)?.length ?? 0,
        };

        // Run when a plan is selected, declined (null), or product is not insurable (null). Skip only while still initializing ("").
        if (productionExternalid !== "" || !isInsurable) {
            if (isDealUnitUpdateInProgress) {
                console.debug('[MoveInCost] effect skipped (unit update in progress)', effectSnapshot);
                return;
            }
            if (deferMoveInCostForUnitPatchRef.current && type === 2) {
                console.debug('[MoveInCost] effect skipped (deferred for unit patch)', effectSnapshot);
                return;
            }
            if (!isType2Ready) {
                console.debug('[MoveInCost] effect skipped (type 2 dependencies not ready)', effectSnapshot);
                return;
            }
            if (type === 2 && noOthersAvailableType2) {
                console.debug('[MoveInCost] effect skipped (no units in unit group)', effectSnapshot);
                return;
            }
            console.debug('[MoveInCost] effect triggered', effectSnapshot);
            void (async () => {
                if (periods > 0) {
                    await getMoveincostApi({
                        trigger: 'effect',
                        moveInCostUpdateMode: 'transactionDetailsOnly',
                        requestPeriods: 0,
                    });
                    await getMoveincostApi({
                        trigger: 'effect',
                        moveInCostUpdateMode: 'recurringOnly',
                        requestPeriods: periods,
                    });
                } else {
                    await getMoveincostApi({ trigger: 'effect' });
                }
            })();
        } else {
            console.debug('[MoveInCost] effect skipped (missing protection plan external id)', effectSnapshot);
        }
    }, [productionExternalid, isInsurable, is_promo_deferred, Movindate, selectedMonth, merchandisedata, selectedUnit, unitNotInUnitsArrayType2, noOthersAvailableType2, type, isDealUnitUpdateInProgress, reservationDetails, unitloading, rentData.ExternalUnitId, rentalData?.externalUnitId, periods])

    type GetMoveInCostOpts = {
        reservationDetailsOverride?: typeof reservationDetails;
        /** After unit PATCH; React state may not have caught up yet */
        type2ExternalUnitIdOverride?: string | null;
        /** Debug only: source of trigger */
        trigger?: 'effect' | 'unit-change' | 'manual' | 'unknown';
        /** Override `periods` sent to the move-in-cost API (defaults to current `periods` state). */
        requestPeriods?: number;
        /**
         * What to update from this response. Use `transactionDetailsOnly` + `recurringOnly` with
         * `requestPeriods` 0 vs N so Payment Periods does not change Transaction Details.
         */
        moveInCostUpdateMode?: 'all' | 'transactionDetailsOnly' | 'recurringOnly';
    };

    const getMoveincostApi = async (opts?: GetMoveInCostOpts) => {
        if (type === 2 && noOthersAvailableType2) {
            console.debug('[MoveInCost] skip request (no units in unit group)');
            return;
        }
        const resDetails = opts?.reservationDetailsOverride ?? reservationDetails;
        const moveInDate = resDetails?.deal?.move_in_date ? dayjs(resDetails.deal.move_in_date) : null;
        const Unit = resDetails?.deal?.unit;
        const minDates = moveInDate?.isAfter(todaydate) || moveInDate?.isBefore(todaydate) ? todaydate : moveInDate;
        const maxDates = moveInDate?.isBefore(todaydate) ? todaydate : moveInDate;
        if (type === 2) {
            setMinDate(minDates || dayjs());
            setMaxDate(maxDates || dayjs())
        }

        let type1ResolvedExternalUnitId: string | null = null;
        if (type === 1) {
            if (selectedUnit) {
                type1ResolvedExternalUnitId = String(selectedUnit);
            } else if (rentData.ExternalUnitId != null && Number(rentData.ExternalUnitId) !== 0) {
                type1ResolvedExternalUnitId = String(rentData.ExternalUnitId);
            } else if (params?.externalUnitId != null) {
                type1ResolvedExternalUnitId = String(params.externalUnitId);
            }
        }

        let type2ResolvedExternalUnitId: string | null = null;
        if (type === 2) {
            if (opts?.type2ExternalUnitIdOverride) {
                type2ResolvedExternalUnitId = String(opts.type2ExternalUnitIdOverride);
            } else if (unitNotInUnitsArrayType2 && unitOptionsType2.length > 0) {
                type2ResolvedExternalUnitId = String(unitOptionsType2[0].external_id);
            } else {
                const fromRent = rentData.ExternalUnitId;
                if (fromRent != null && Number(fromRent) !== 0) {
                    type2ResolvedExternalUnitId = String(fromRent);
                } else if (selectedUnit) {
                    type2ResolvedExternalUnitId = String(selectedUnit);
                } else if (rentalData?.externalUnitId != null && rentalData.externalUnitId !== '') {
                    type2ResolvedExternalUnitId = String(rentalData.externalUnitId);
                }
            }
        } else {
            // type 1 selectedUnit is initialized from params/existing rental data.
        }
        const savedata = merchandisedata?.filter((item) => item.quantity !== 0) || [];
        const mergedDataMap = savedata?.map((item) => ({
            external_id: item.external_id?.toString(),
            quantity: item.quantity?.toString(),
            name: item.name,
            id: item.id,
        }));
        const savedDataMap = savedata?.map((item) => ({

            external_id: item.external_id?.toString(),
            quantity: item.quantity?.toString(),
        }));

        const requestPeriods = opts?.requestPeriods ?? periods;
        // Omit TPP when product is not insurable or Decline is selected (productionExternalid null/empty)
        const externalTppId =
            isInsurable && productionExternalid
                ? productionExternalid.toString()
                : null;
        const requestData = {
            external_unit_id: type === 1
                ? type1ResolvedExternalUnitId
                : type2ResolvedExternalUnitId,
            move_in_date: type === 1
                ? rentData.start_date
                : (Movindate.toString() || ""),
            is_promo_deferred: is_promo_deferred,
            external_merchandise: savedDataMap ? savedDataMap : [],
            quoted_price: null,
            periods: requestPeriods,
            external_promotion_id: selectedMonth?.label === 'No Promo' ? null : type === 1 ? params?.promotionId : rentalData?.external_promotion_id,
            external_tpp_id: externalTppId,
            ...(type === 2 && rentalData?.externalId ? { external_deal_id: rentalData.externalId } : {}),
        };

        if (type === 2) {
            if (!requestData.external_unit_id || !requestData.move_in_date) {
                console.warn('[MoveInCost] skip request due to incomplete type 2 payload', {
                    trigger: opts?.trigger ?? 'unknown',
                    external_unit_id: requestData.external_unit_id,
                    move_in_date: requestData.move_in_date,
                    selectedUnit,
                    rentExternalUnitId: rentData.ExternalUnitId,
                    rentalExternalUnitId: rentalData?.externalUnitId ?? null,
                });
                return;
            }
        }

        const requestKey = JSON.stringify({
            facilityId: FacilityId,
            requestData,
        });
        const now = Date.now();
        const debug = moveInCostDebugRef.current;
        const requestId = ++debug.seq;
        const apiBase = (window.config?.apiUrl || '').replace(/\/+$/, '');
        const expectedEndpoint = `${apiBase}/facilities/${FacilityId}/move-in-cost`;

        if (debug.inFlight && debug.lastRequestKey === requestKey) {
            console.warn(`[MoveInCost#${requestId}] duplicate blocked (in-flight same request)`, {
                trigger: opts?.trigger ?? 'unknown',
                expectedEndpoint,
                requestData,
            });
            return;
        }

        if (debug.lastRequestKey === requestKey && now - debug.lastStartedAt < 1200) {
            console.warn(`[MoveInCost#${requestId}] duplicate blocked (same request within 1200ms)`, {
                trigger: opts?.trigger ?? 'unknown',
                elapsedMs: now - debug.lastStartedAt,
                expectedEndpoint,
                requestData,
            });
            return;
        }

        debug.inFlight = true;
        debug.lastRequestKey = requestKey;
        debug.lastStartedAt = now;

        console.groupCollapsed(`[MoveInCost#${requestId}] request start`);
        console.debug(`[MoveInCost#${requestId}] trigger`, opts?.trigger ?? 'unknown');
        console.debug(`[MoveInCost#${requestId}] expected endpoint`, expectedEndpoint);
        console.debug(`[MoveInCost#${requestId}] requestData`, requestData);

        try {
            const result: MoveInCostResponse = await getMoveInCost({ data: requestData, facilityId: FacilityId }).unwrap();
            if (result?.costs) {
                console.debug(`[MoveInCost#${requestId}] success`, {
                    dueNow: result.costs?.pms_total_for_movein,
                    rent: result.costs?.rent,
                    fees: result.costs?.fees?.length ?? 0,
                });
                const updateMode = opts?.moveInCostUpdateMode ?? 'all';
                if (updateMode === 'all' || updateMode === 'recurringOnly') {
                    setCost(result.costs);
                }
                if (updateMode === 'all' || updateMode === 'transactionDetailsOnly') {
                    setTransactionDetailsCost(result.costs);
                    const paymentAmount = parseFloat(result.costs?.pms_total_for_movein);
                    const finalPaymentAmount = isNaN(paymentAmount) ? 0 : parseFloat(paymentAmount.toFixed(2));
                    const administrativeFee = result.costs.fees?.find(fee => fee.name === "Administrative Fee");

                    const feeIds = result?.costs?.fees
                        ?.filter(fee => fee.external_id && fee.external_id !== "unknown")
                        .map(fee => `${fee.external_id}`).join(',');
                    // Ensure it logs correctly without extra wrapping quotes
                    console.log(feeIds);

                    setrentData({
                        ...rentData,
                        Move_in_cost: finalPaymentAmount,
                        ExternalUnitId: type === 1
                            ? (type1ResolvedExternalUnitId != null ? Number(type1ResolvedExternalUnitId) : externalUnitId)
                            : type2ResolvedExternalUnitId ?? rentalData?.externalUnitId?.toString() ?? null,
                        UnitSize: type === 1 ? rentalData?.unitSize : resDetails?.deal?.unit_dimensions || "",
                        Features: type === 1 ? rentalData?.features : `${Unit?.is_climate === 1 ? 'Climate' : 'Inside'}${Unit?.floor === 1 ? ', First Floor' : Unit?.floor && Unit.floor > 1 ? ', Upper' : ''}`,
                        MonthlyRate: type === 1 ? rentalData.rent : resDetails?.deal?.quoted_price?.toString() || "",
                        Promotion: rentalData?.promotion ?? "",
                        quoted_rate: type === 1 ? rentalData?.price_formatted : resDetails?.deal?.quoted_price?.toString() || "",
                        PromotionStart: "",
                        UnitNumber: "",
                        FirstMonthRent: result.costs?.rent,
                        AdministrativeFee: administrativeFee ? Number(administrativeFee.cost) : 0,
                        RentTax: result.costs?.rent_tax ? Number(result?.costs.rent_tax) : 0,
                        FacilityId: FacilityId,
                        External_fee_id: feeIds,
                        price_formatted: rentalData?.price_formatted ?? "",
                        DueNow: result?.costs?.pms_total_for_movein ? Number(result?.costs?.pms_total_for_movein) : 0,
                        Insurance: selectedPremium.toFixed(2) ? Number(selectedPremium.toFixed(2) || 0.00) : 0,
                        InsuranceValue: result?.costs?.tpp || 0.00 ? Number(result?.costs?.tpp || 0.00) : 0,
                        ScriptValue: script,
                        ExternalDealId: type === 1 ? rentalData?.dealid : rentalData.externalId || "",
                        ExternalPromotionId: type === 1 ? "" : rentalData?.external_promotion_id?.toString() || "",
                        promoid: type === 1 ? params?.promotionId!.toString() : rentalData?.external_promotion_id,
                        merchandfee: result?.costs?.merchandise || "",
                        salestax: result?.costs?.sales_tax || "",

                    });
                    setselectedMerchandise(mergedDataMap);
                }
            }
        } catch (error) {
            console.error(`[MoveInCost#${requestId}] Failed to fetch move-in costs:`, error);
            const detail =
                getApiErrorMessage(error) ??
                'Could not load move-in costs. Please try again.';
            const isNoUnitsInUnitGroupMsg =
                detail.trim().toLowerCase() ===
                'no units are available from this unit group'.toLowerCase();
            if (!isNoUnitsInUnitGroupMsg) {
                AircallNofity({ type: 'error', Msg: detail });
            }
        } finally {
            moveInCostDebugRef.current.inFlight = false;
            console.groupEnd();
        }
    }
    
    // Email validation helper function
    const isValidEmail = (email: string): boolean => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };
    
    // Get email error message
    const getEmailErrorMessage = (): string => {
        if (rentData.customerinfoemail === '') {
            return "Please Enter Email";
        } else if (!isValidEmail(rentData.customerinfoemail)) {
            return "Please Enter Valid Email Address";
        }
        return "";
    };
    
    // validators
    const validation = (headerToExpand: string) => {
        if (periods > 0 && headerToExpand === 'Paymentheader') {
            setPeriodsValidationError(true);
            AircallNofity({ type: 'error', Msg: PERIODS_BLOCK_ERROR_MESSAGE });
            return;
        }

        let isfail = false;
        let isinsurancefail = false;
        const newErrors = {
            customerinfofirstname: false,
            customerinfolastname: false,
            customerinfoaddress1: false,
            customerinfoaddress2: false,
            customerinfocity: false,
            customerinfoPostalcode: false,
            customerinfophone: false,
            customerinfoemail: false,
            IdTNumber: false,
            IdIssuer: false,
            Description: false,
            CoverageAmt: false,
            PolicyNumber: false,
            militaryStatusidnumber: false,
            militaryStatusbranch: false,
            IdType: false
        };

        // Start validating all fields and mark errors
        if (rentData.customerinfofirstname === '' || rentData.customerinfofirstname === null) {
            newErrors.customerinfofirstname = true;
            isfail = true;
        }
        if (rentData.customerinfolastname === '' || rentData.customerinfolastname === null) {
            newErrors.customerinfolastname = true;
            isfail = true;
        }
        if (rentData.customerinfoaddress1 === '' || rentData.customerinfoaddress1 === null) {
            newErrors.customerinfoaddress1 = true;
            isfail = true;
        }
        if (rentData.customerinfocity === '' || rentData.customerinfocity === null) {
            newErrors.customerinfocity = true;
            isfail = true;
        }
        if (rentData.customerinfoPostalcode === '' || rentData.customerinfoPostalcode === null) {
            newErrors.customerinfoPostalcode = true;
            isfail = true;
        }
        if (!rentData.customerinfoPostalcode ||
            (rentData.customerinfoPostalcode.length !== 5 && rentData.customerinfoPostalcode.length !== 10)) {
            AircallNofity({ type: 'error', Msg: 'Post Code value must be 5 or 9 digits' });
            isfail = true;
        }
        if (rentData.ProperityBeingStored.length === 0) {
            AircallNofity({ type: 'error', Msg: 'Please choose Property Being Stored' });
            isfail = true;
        }
        const customerPhoneDigits = rentData.customerinfophone.replace(/\D/g, '');
        if (
            rentData.customerinfophone.trim() === '' ||
            customerPhoneDigits.length !== 10
        ) {
            newErrors.customerinfophone = true;
            isfail = true;
            AircallNofity({ type: 'error', Msg: 'Please enter a valid 10-digit phone number!' });
        }
        if (rentData.customerinfoemail === '') {
            newErrors.customerinfoemail = true;
            isfail = true;
        } else if (!isValidEmail(rentData.customerinfoemail)) {
            newErrors.customerinfoemail = true;
            isfail = true;
        }
        if (rentData.customerinfostate === '' || rentData.customerinfostate === null || rentData.customerinfostate === undefined) {
            newErrors.IdIssuer = true;
            isfail = true;
            AircallNofity({ type: 'error', Msg: 'Please Choose State' });
        }
        if (rentData.IdType === '' || rentData.IdType === null || rentData.IdType === undefined) {
            newErrors.IdType = true;
            isfail = true;
            AircallNofity({ type: 'error', Msg: 'Please Choose ID Type' });
        }
        if (rentData.IdType !== "passport" && (rentData.IdIssuer === '' || rentData.IdIssuer === null || rentData.IdIssuer === undefined)) {
            newErrors.IdIssuer = true;
            isfail = true;
            AircallNofity({ type: 'error', Msg: 'Please Choose ID Issuer' });
        }
        if (rentData.IdTNumber === '' || rentData.IdTNumber === null || rentData.IdTNumber === undefined) {
            newErrors.IdTNumber = true;
            isfail = true;
        }
        if (rentData.militaryStatus === '' || rentData.militaryStatus === null) {
            isfail = true;
            AircallNofity({ type: 'error', Msg: 'Please Choose Military Status' });
        }

        if (isOtherChecked === true) {
            if (rentData.Otherproperitys === '' || rentData.Otherproperitys === null) {

                AircallNofity({ type: 'error', Msg: 'Please Enter the Other Property' });
                isfail = true;
            }
        }
        if (rentData.militaryStatus === "4" || rentData.militaryStatus === "5") {
            if (rentData.militaryStatusidnumber === '') {
                newErrors.militaryStatusidnumber = true;
                isfail = true;
            }
            if (rentData.militaryStatusbranch === '' || rentData.militaryStatusbranch === null) {
                isfail = true;
                AircallNofity({ type: 'error', Msg: 'Please Choose Military Status Branch' });
            }
            if (!rentData.militaryStatusidnumber || rentData.militaryStatusidnumber.length < 10) {
                newErrors.militaryStatusidnumber = true;
                isfail = true;
            }
        }

        // Set errors once after validation
        setErrors((prev) => ({ ...prev, ...newErrors }));

        // Scroll to the section with errors
        if (isfail) {
            handleNext('Informationheader');
            requestAnimationFrame(() => {
                const element = document.getElementById('header-info');
                if (element) {
                    element.scrollIntoView({ behavior: 'smooth' });
                }
            });
        } else if (isinsurancefail) {
            handleNext('Insuranceheader');
            requestAnimationFrame(() => {
                const element = document.getElementById('insuranceaccoupant');
                if (element) {
                    element.scrollIntoView({ behavior: 'smooth' });
                }
            });
        } else {
            handleNext(headerToExpand);
        }
    };
    // on change events
    const handleMonthChange = (event: React.ChangeEvent<{}>, newValue: MonthOption | null) => {
        if (newValue) {
            if (newValue.label === 'This Month') {
                setrentData({
                    ...rentData,
                    selectedMonth: newValue.label,
                    is_promo_deferred: false,
                    promoid: promoId,
                });
                setis_promo_deferred(false)
            } else if (newValue.label === 'Next Month') {
                setrentData({
                    ...rentData,
                    selectedMonth: newValue.label,
                    is_promo_deferred: true,
                    promoid: promoId,
                });
                setis_promo_deferred(true)
            } else if (newValue.label === 'No Promo') {
                setrentData({
                    ...rentData,
                    selectedMonth: newValue.label,
                    is_promo_deferred: false,
                    promoid: ""
                });
                setis_promo_deferred(false)
            }
            setSelectedMonth(newValue);
        }
    };
    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const { name, value, type } = e.target;

        if (type === "text" && (value === null || value.trim() === "")) {
            setErrors({
                ...errors,
                [name]: true,
            });
            setrentData({
                ...rentData,
                [name]: value,
            });
            return;
        }
        // Phone: allow any formatting while typing; cap at 10 digits; normalize on blur
        if (name === 'emergencyContactphone' || name === 'customerinfophone') {
            const digits = value.replace(/\D/g, '');
            const nextValue = digits.length > 10 ? digits.slice(0, 10) : value;
            setrentData({
                ...rentData,
                [name]: nextValue,
            });
        }
        else if (name === 'customerinfocity') {
            // Allow only letters and spaces
            const isValid = /^[A-Za-z\s]*$/.test(value);
            if (isValid) {
                setrentData({
                    ...rentData,
                    [name]: value,
                });
            }

        }
        else if (name === 'militaryStatusidnumber') {
            const cleanedValue = value.replace(/\D/g, ''); // Remove non-digit characters
            let formattedValue = cleanedValue;
            setrentData({
                ...rentData,
                [name]: formattedValue,
            });
        }

        else {
            setrentData({
                ...rentData,
                [name]: value,
            });
        }
        // Clear errors for valid input
        setErrors({
            ...errors,
            [name]: false,
        });
    };
    const AutocompleteChange = (name: string) => (event: React.SyntheticEvent, value: { Id: string; label: string } | null) => {
        if (name === "IdType") {
            if (value && value.Id === 'passport') {
                setrentData((prevData) => ({
                    ...prevData,
                    IdIssuer: '',
                }));
            }
        }
        setrentData((prevData) => ({
            ...prevData,
            [name]: value ? value.Id : '',
        }));
    }
    const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { name, checked } = event.target;
        const updatedCheckedItems = checked
            ? [...checkedItems, name]
            : checkedItems.filter(item => item !== name);
        setCheckedItems(updatedCheckedItems);
        if (updatedCheckedItems.includes("Other")) {
            setIsOtherChecked(true);
        } else {
            setIsOtherChecked(false);
            setrentData(prevState => ({
                ...prevState,
                Otherproperitys: ""
            }));
        }
        setrentData(prevState => ({
            ...prevState,
            ProperityBeingStored: updatedCheckedItems
                .join(", "), // Join remaining items with a comma and space
        }));
    };
    const commentChange = (e: React.ChangeEvent<HTMLTextAreaElement>): void => {
        setrentData({
            ...rentData,
            Otherproperitys: e.target.value
        });
    };
    const handlePostalCodeChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
        let value = e.target.value;

        // Allow only digits
        value = value.replace(/\D/g, ""); // Remove all non-digit characters
        let formattedValue = value;

        // Enforce maximum length of 9
        if (value.length > 9) {
            value = value.slice(0, 9);
        }

        // Format the value with a hyphen if 9 digits are entered
        if (value.length === 9) {
            formattedValue = `${value.slice(0, 5)}-${value.slice(5, 9)}`;
        } else {
            formattedValue = value; // No hyphen if less than 9 digits
        }

        // Update state with formatted value
        setrentData({ ...rentData, customerinfoPostalcode: formattedValue });

        // Set error state for invalid length
        if (value.length >= 5 && value.length <= 9) {
            setErrors({ ...errors, customerinfoPostalcode: false });
        } else {
            setErrors({ ...errors, customerinfoPostalcode: true });
        }
    };
    const handlecheckChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        setrentData((prevData) => ({
            ...prevData,  //
            Description: '',
            CoverageAmt: '',
            PolicyNumber: '',
            PolicyStartDate: dayjs(),
            PolicyEndDate: dayjs().add(1, 'day'),
        }));
        const { value } = e.target;
        // Find the matching insurance plan
        setinsurance(value);
        setrentData((prevData) => ({
            ...prevData,
            selectinsurence: value,
        }));
        const selectedInsurance = prodectionplan.find(
            (protectionPlan) => protectionPlan.id.toString() === value
        );
        if (selectedInsurance) {
            setproductionExternalid(selectedInsurance.external_id)
            // Set the premium value from the selected insurance
            setSelectedPremium(selectedInsurance.premium);
            setrentData((prevData) => ({
                ...prevData,  //
                prodection_external_id: selectedInsurance.external_id,
                promoname: selectedInsurance.name || "",
                promoprice: selectedInsurance.coverage.toString(),
            }));
        }
        else {
            setproductionExternalid(null)
            setSelectedPremium(0);
            setrentData((prevData) => ({
                ...prevData,  //
                promoname: "",
                promoprice: "",
                prodection_external_id: "",

            }));
        }
    };
    const tagdatasave = () => {
        // Setting Data Read from the session storage
        const SettingData = sessionStorage.getItem('setting');
        const Settings = SettingData ? JSON.parse(SettingData) : [];
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const IsLead = Settings.is_deal_type_lead_enabled;
        const tagdata = sessionStorage.getItem('tagsdata');
        const tagdataObject = tagdata ? JSON.parse(tagdata) : {};
        const tags = tagdataObject.tags || [];
        // reservation new tags
        const Rentaldata = tags.find((tag: { name: string }) => tag.name === 'Rental');
        // Find tags based on names
        const Reservationconvert = tags.find((tag: { name: string }) => tag.name === 'Reservation - Converted');
        const IsLeaddataconvert = tags.find((tag: { name: string }) => tag.name === 'Lead - Converted');
        const Speedrent = tags.find((tag: { name: string }) => tag.name === 'SpeedeRent');

        if (rentData?.label === 'convert') {
            dispatch(addId(Reservationconvert.id));
            dispatch(addId(Rentaldata?.id));
            if (rentData.type === "lead") {
                dispatch(addId(IsLeaddataconvert.id));
            }
            if (Speedrent) {
                dispatch(addId(Speedrent?.id));
            }
        }
        if (rentData?.label === 'New') {
            dispatch(addId(Rentaldata?.id));

            if (Speedrent) {
                dispatch(addId(Speedrent?.id));
            }

        }
        if (rentData?.label === 'Update') {
            if (rentData.type === "lead") {
                dispatch(addId(IsLeaddataconvert.id));
            }
            dispatch(addId(Rentaldata?.id));
            if (Speedrent) {
                dispatch(addId(Speedrent?.id));
            }
        }


    };
    // speed rent calcultion for both
    const end_date = getLastDayOfCurrentMonth();
    const speedrentcalc = async () => {
        let savesuccess = true;
        setrentData({ ...rentData, speedrent: true });
        // Retrieve agent's full name from session storage
        const agentName = sessionStorage.getItem('FirstName') + ' ' + sessionStorage.getItem('LastName');
        // Construct the rented object with necessary details
        const { ProperityBeingStored, Otherproperitys } = rentData;
        const dataToSend =
            Otherproperitys?.trim()
                ? `${ProperityBeingStored}, ${Otherproperitys}`
                : ProperityBeingStored;
        const rented = {
            external_unit_id: rentData.ExternalUnitId.toString(),
            payment_amount: rentData.Move_in_cost,
            start_date: rentData.start_date,
            end_date: end_date, // Consider making this dynamic
            is_promotion_deferred: rentData.is_promo_deferred,
            external_occupant_id: rentData.occupancyid !== "" ? rentData.occupancyid : null,
            external_deal_id: rentData.ExternalDealId || null,
            external_tpp_id:
                rentData.is_insurable !== false && rentData.prodection_external_id
                    ? rentData.prodection_external_id
                    : null,
            external_promotion_id: selectedMonth?.label === 'No Promo'
                ? null  // If selectedMonth label is 'No Promo', set external_promotion_id to null
                : (type === 1
                    ? (params?.promotionId ? params.promotionId.toString() : null)  // If type is 1, set promotionId or null if not available
                    : (rentalData?.external_promotion_id || null)),
            external_fee_ids: [rentData.External_fee_id.toString()],
            first_name: rentData.customerinfofirstname,
            last_name: rentData.customerinfolastname,
            address1: rentData.customerinfoaddress1,
            address2: rentData.customerinfoaddress2,
            city: rentData.customerinfocity,
            state: rentData.customerinfostate,
            zip: rentData.customerinfoPostalcode,
            email: rentData.customerinfoemail,
            phone: rentData.customerinfophone,
            phone_alt: "", // Consider if this should be null instead
            autopay: true,
            customer_source: "Store Main Number",
            quoted_rate: formatQuotedRate(rentData.quoted_rate),
            vehicle_storage: false,
            id_number: rentData.IdTNumber,
            id_type: rentData.IdType,
            id_state: rentData.IdIssuer,
            is_business: false,
            business_name: "",
            source: "call-center",
            is_gift_card_eligible: false,
            agent: agentName,
            storage_contents: dataToSend,
            is_occupant_tpp: rentData.selectinsurence === "1" ? true : false,
            occupant_tpp_description: rentData.selectinsurence === "1" ? rentData.Description : null,
            occupant_tpp_policy_number: rentData.selectinsurence === "1" ? rentData.PolicyNumber : null,
            occupant_tpp_start_date: rentData.selectinsurence === "1" ? rentData.PolicyStartDate : null,
            occupant_tpp_end_date: rentData.selectinsurence === "1" ? rentData.PolicyEndDate : null,
            occupant_tpp_coverage_amount: rentData.selectinsurence === "1" ? rentData.CoverageAmt : null,
            military_status: rentData.militaryStatus,
            military_branch: rentData.militaryStatusbranch ? rentData.militaryStatusbranch : null,
            military_id: rentData.militaryStatusidnumber ? rentData.militaryStatusidnumber : null,
        };
        if (noOthersAvailableType2) {
            AircallNofity({ type: 'error', Msg: 'The original unit has been rented. There are no more available units in this group. Please return to the Facility Page, manage deal and select a new available unit.' });
            savesuccess = false;
        }
        else if (rentData.customerinfoemail === '') {
            AircallNofity({ type: 'error', Msg: 'Please enter email address!' });
            savesuccess = false
        }
        else if (!isValidEmail(rentData.customerinfoemail)) {
            AircallNofity({ type: 'error', Msg: 'Please enter a valid email address!' });
            savesuccess = false
        }
        else if (
            rentData.customerinfophone.trim() === '' ||
            rentData.customerinfophone.replace(/\D/g, '').length !== 10
        ) {
            AircallNofity({ type: 'error', Msg: 'Please enter a valid 10-digit phone number!' });
            savesuccess = false;
            setErrors((prev) => ({ ...prev, customerinfophone: true }));
            handleNext('Informationheader');
            requestAnimationFrame(() => {
                const element = document.getElementById('header-info');
                element?.scrollIntoView({ behavior: 'smooth' });
            });
        }
        else if (rentData.customerinfolastname === "") {
            AircallNofity({ type: 'error', Msg: 'Please enter last name!' });
            savesuccess = false
        }
        else if (rentData.customerinfofirstname === "") {
            AircallNofity({ type: 'error', Msg: 'Please enter first name!' });
            savesuccess = false
        }
        else if (rentData.customerinfoaddress1 === "") {
            AircallNofity({ type: 'error', Msg: 'Please enter address!' });
            savesuccess = false
        }
        else if (rentData.customerinfocity === "") {
            AircallNofity({ type: 'error', Msg: 'Please enter city!' });
            savesuccess = false
        }
        else if (rentData.customerinfostate === "") {
            AircallNofity({ type: 'error', Msg: 'Please enter state!' });
            savesuccess = false
        }
        else if (rentData.customerinfoPostalcode === "") {
            AircallNofity({ type: 'error', Msg: "Please enter postal code!" });
            savesuccess = false
        }
        else if (rentData.IdType === "") {
            AircallNofity({ type: 'error', Msg: "Please enter ID Type!" });
            savesuccess = false
        }
        else if (rentData.IdTNumber === "") {
            AircallNofity({ type: 'error', Msg: "Please enter ID Number!" });
            savesuccess = false
        }
        else if (rentData.IdType !== "passport" && rentData.IdIssuer === "") {
            AircallNofity({ type: 'error', Msg: "Please enter ID Issuer!" });
            savesuccess = false
        }
        else if (rentData.ProperityBeingStored.length === 0) {
            AircallNofity({ type: 'error', Msg: 'Please choose Property Being Stored' });
            savesuccess = false;
        }
        if (!rentData.customerinfoPostalcode ||
            (rentData.customerinfoPostalcode.length !== 5 && rentData.customerinfoPostalcode.length !== 10)) {
            AircallNofity({ type: 'error', Msg: 'Post Code value must be 5 or 9 digits' });
            savesuccess = false;
        }
        if (isOtherChecked === true) {
            if (rentData.Otherproperitys === '' || rentData.Otherproperitys === null) {

                AircallNofity({ type: 'error', Msg: 'Please Enter the Other Property' });
                savesuccess = false;
            }
        }
        if (rentData.militaryStatus === "4" || rentData.militaryStatus === "5") {
            if (rentData.militaryStatusidnumber === '') {
                AircallNofity({ type: 'error', Msg: 'Please Enter Military Status ID Number' });
                savesuccess = false
            }
            if (rentData.militaryStatusbranch === '' || rentData.militaryStatusbranch === null) {

                AircallNofity({ type: 'error', Msg: 'Please Choose Military Status Branch' });
                savesuccess = false
            }
            if (!rentData.militaryStatusidnumber || rentData.militaryStatusidnumber.length < 10) {
                AircallNofity({ type: 'error', Msg: 'Military ID number should not be less than 10 digits' });
                savesuccess = false
            }
        }

        try {
            // Make the request to post rent data
            if (savesuccess) {
                setispeedloading(true);
                const result = await PostSpeedeRent({ rented, facilityId }).unwrap();
                // Notify the user based on the result
                if (result.status === 1) {
                    setispeedloading(false);
                    AircallNofity({ type: 'success', Msg: 'Speede Rent Move-In Was Successful' });
                    tagdatasave();
                    setIsDialogOpen(true);
                } else {
                    setispeedloading(false);
                    AircallNofity({ type: 'error', Msg: 'Speede Rent Failed' });
                }
            }
        } catch (error) {
            setispeedloading(false);
            toast.error('Speede Rent failed');
        }
    };
    // Logic for the onClick event
    const handleLookupTenant = () => {
        setIslookup(true);
        setrentData((prevData) => ({
            ...prevData,
            customerinfofirstname: "",
            customerinfolastname: "",
            customerinfoaddress1: "",
            customerinfoaddress2: "",
            customerinfocity: "",
            customerinfostate: "",
            customerinfoPostalcode: "",
            customerinfophone: "",
            customerinfoemail: "",
            occupancyid: "",
            external_id: "",
        }));
        requestAnimationFrame(() => {
            const element = document.getElementById('occupant-info');
            if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
                if (firstNameInputRef.current) {
                    firstNameInputRef.current.focus();
                }
            }

        });
    };
    //Search Handle change
    const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setSearchdata({
            ...searchdata,
            [name]: value,
        });
    }
    // occupnt data 
    const CustomNoResultsOverlay = () => (
        <Box textAlign="center" p={2}>
            <Typography variant="h6">No Data Available</Typography>
        </Box>
    );
    // set occupant data
    const SetOccupancyData = (params: any) => {
        const data = params.row;
        setrentData((prevData) => ({
            ...prevData,
            customerinfofirstname: data?.first_name || '',
            customerinfolastname: data?.last_name || '',
            customerinfoaddress1: data?.address || '',
            customerinfoaddress2: data?.address2 || '',
            customerinfocity: data?.city || '',
            customerinfostate: data?.state || '',
            customerinfoPostalcode: data?.postal_code || '',
            customerinfophone: formatPhoneNumber(data?.phone_number || ''),
            customerinfoemail: data?.email || '',
            occupancyid: (data?.external_id).toString() || '',
            FacilityId: data?.facility_id || '',
            external_id: data?.id.toString() || '',
            IdType: data.id_type || '',
            IdTNumber: data.id_number || '',
            IdIssuer: data.id_state || '',
            militaryStatus: data?.military_status?.toString() || '',
            militaryStatusbranch: data?.military_branch?.toString() || '',
            militaryStatusidnumber: data?.military_id || ''

        }));
        setIslookup(false);
        setIsgrid(false);
        setSearchdata({
            ...searchdata,
            firstnamesearch: '',
            lastnamesearch: '',
            accesscodesearch: '',
            emailsearch: '',
            phonesearch: ''
        });
        window.scrollTo({
            top: 300, // Adjust this value as needed
            behavior: 'smooth' // Adds a smooth scroll effect
        });
    };
    // columns def
    const colDefs: GridColDef[] = [
        { field: 'first_name', headerName: 'First Name', minWidth: 150 },
        { field: 'last_name', headerName: 'Last Name', minWidth: 150 },
        { field: 'address', headerName: 'Address', minWidth: 150 },
        { field: 'access_code', headerName: 'Access Code', minWidth: 150, filterable: false, sortable: false },
        {
            field: "phone_number",
            headerName: "Phone",
            minWidth: 150,
            headerAlign: 'center', align: 'center',
            flex: 1,
            valueGetter: (params) => {
                const phone = params; // Accessing the phone directly
                return phone ? formatPhoneNumber(phone) : 'N/A'; // Assuming formatPhoneNumber is a valid function
            },
        },
        { field: 'email', headerName: 'Email', minWidth: 230 },
        {
            field: 'action',
            headerName: 'Action',
            flex: 1,
            minWidth: 150,
            filterable: false,
            sortable: false,
            renderCell: (params) => (
                <div style={{ display: 'flex', alignItems: 'center', height: '100%' }}>
                    <Button size="small" variant="contained" onClick={() => SetOccupancyData(params)}>select</Button>
                </div>
            ),
        },
    ];
    // Grid Loaded based on the search value
    const [trigger, { data: occupancyData, isFetching }] = useLazyGetOccupancyDataQuery();
    const handleLookupTenantSearch = async () => {
        if (searchdata.emailsearch.length < 1 && searchdata.firstnamesearch.length < 1 && searchdata.lastnamesearch.length < 1 && searchdata.accesscodesearch.length < 1 && searchdata.phonesearch.length < 1) {
            setIsgrid(false)
            AircallNofity({ type: 'error', Msg: 'Please enter atleast one search criteria' });
        }
        else {
            setIsgrid(true)
            try {
                await trigger({
                    facilityid: FacilityId,
                    email: searchdata.emailsearch.toLowerCase(),
                    firstname: searchdata.firstnamesearch.toLowerCase(),
                    lastname: searchdata.lastnamesearch.toLowerCase(),
                    accesscode: searchdata.accesscodesearch,
                    phone: searchdata.phonesearch
                });
            } catch (err) {
                toast.error('Error fetching occupancy data');
            }
        }
    };

    useEffect(() => {
        if (occupancyData) {
            setGridData(occupancyData);
        }
    }, [occupancyData, externalUnitId]);

    //Load test Data
    const TestLoadData = (data: unknown) => {
        function getRandomThreeDigitNumber() {
            return Math.floor(Math.random() * 900) + 100;
        }
        const randomThreeDigitNumber = getRandomThreeDigitNumber();
        if (data === "Information") {
            const nextYear = (new Date().getFullYear() + 1).toString().slice(-2);
            setrentData((prevData) => ({
                ...prevData,
                customerinfofirstname: type === 1 ? (`John${randomThreeDigitNumber}`) : prevData.customerinfofirstname,
                customerinfolastname: type === 1 ? (`Doe${randomThreeDigitNumber}`) : prevData.customerinfolastname,
                customerinfoaddress1: "132 My Street",
                customerinfoaddress2: "street2",
                customerinfocity: "Kingston",
                customerinfostate: "AL",
                customerinfoPostalcode: "12401",
                customerinfophone: type === 1 ? (`${randomThreeDigitNumber}-456-7890`) : prevData.customerinfophone,
                customerinfoemail: type === 1 ? (`johndoe${randomThreeDigitNumber}@example.com`) : prevData.customerinfoemail,
                IdType: "dl",
                IdTNumber: "146825129",
                IdIssuer: "AL",
                emergencyContactfirstname: `Roger${randomThreeDigitNumber}`,
                emergencyContactlastname: `smith${randomThreeDigitNumber}`,
                emergencyContactphone: `${randomThreeDigitNumber}-111-1111`,
                isactivemillitary: "yes",
                militaryStatus: "1",
                militaryStatusbranch: "",
                militaryStatusidnumber: "",
                isLians: "no",
                ProperityBeingStored: "Household",
                selectinsurence: "0",
                creditfirstname: "Jhon",
                creditlastname: "Smith",
                CredictCardNumber: "4111-1111-1111-1111",
                ExpiryMonth: "02",
                ExpiryYear: nextYear,
                CVV: "789",
                card_zip: "78085",
                card_type: "visa",
                occupancyid: ""
            }));
            setCheckedItems(["Household"]);
        }
        else if (data === "Capture")
            setrentData((prevData) => ({
                ...prevData,
                IdType: "dl",
                IdTNumber: `${randomThreeDigitNumber}4567890`,
                IdIssuer: "AL",

            }));
        else if (data === "Emergency") {
            setrentData((prevData) => ({
                ...prevData,
                emergencyContactfirstname: `Richard${randomThreeDigitNumber}`,
                emergencyContactlastname: `Hughes${randomThreeDigitNumber}`,
                emergencyContactphone: `${randomThreeDigitNumber}-111-1111`,

            }));
        }
        AircallNofity({ type: 'success', Msg: 'Test Data is loaded' });
    };

    const handleIncrement = (id: number) => {
        setMerchandisedata((prev) =>
            prev.map((item) => {
                if (Number(item.id) === id) {
                    const newQuantity = Math.min(item.quantity + 1, Number(item.in_stock));
                    return {
                        ...item,
                        quantity: newQuantity,
                        remaining: Number(item.in_stock) - newQuantity,
                    };
                }
                return item;
            })
        );
    };

    const handleDecrement = (id: number) => {
        setMerchandisedata((prev) =>
            prev.map((item) => {
                if (Number(item.id) === id) {
                    const newQuantity = Math.max(item.quantity - 1, 0);
                    return {
                        ...item,
                        quantity: newQuantity,
                        remaining: Number(item.in_stock) - newQuantity,
                    };
                }
                return item;
            })
        );
    };
    const totalQuantity = merchandisedata.reduce((sum, item) => sum + item.quantity, 0);
    return (
        <>
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={ispeedloading}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
            <Stack direction='row' spacing={1} alignItems={'center'} my={3}>
                <IconButton onClick={() => navigate(`/Dashboard/${facilityId}`)}>
                    <ArrowBackRoundedIcon sx={{ color: 'text.secondary' }} />
                </IconButton>
                <Typography variant='h3' color='text.secondary'>
                    Back to facility page
                </Typography>
            </Stack>
            <Box my={2}>
                <CustomAccordion defaultExpanded>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1-content"
                        id="panel1-header"
                    >
                        <Typography variant="h3" color="text.secondary">Call Script
                        </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography
                            color="text.primary"
                            textAlign={'left'}
                            dangerouslySetInnerHTML={{ __html: removeHtmlTags(script || OperatorAlert[0]?.create_reservation_script || '') }}
                        />
                    </AccordionDetails>
                </CustomAccordion>
            </Box>
            <Box my={2}>
                <Grid container spacing={2}>

                    <Grid size={{ xs: 12, md: 8 }}>
                        <Box mb={2}>
                            <div>
                                <CustomAccordion expanded={expand.Verifyheader} >
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel1-content"
                                        id="panel1-header"
                                        onClick={() => handleAccordionClick('Verifyheader')}
                                    >
                                        <Typography variant="h3" color="text.secondary">Verify Unit, Rental Date, and Promotion</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Grid container spacing={2}>
                                            <Grid size={{ xs: 12, md: 3 }}>
                                                <List>
                                                    <ListItem>
                                                        <ListItemText primary='Unit Size' secondary={type === 1 ? (rentalData?.unitSize) : (reservationDetails?.deal?.unit_dimensions)} />
                                                    </ListItem>
                                                </List>
                                            </Grid>
                                            <Grid size={{ xs: 12, md: 3 }}>
                                                <List>
                                                    <ListItem>
                                                        <ListItemText primary='Unit Type' secondary={rentalData?.external_type_name || reservationDetails?.deal?.unit?.type_name} />
                                                    </ListItem>
                                                </List>
                                            </Grid>
                                            <Grid size={{ xs: 12, md: 3 }}>
                                                <List>
                                                    <ListItem>
                                                        <ListItemText primary='Features' secondary={rentalData?.features || (reservationDetails?.deal?.unit ? `${reservationDetails?.deal?.unit?.is_climate === 1 ? 'Climate' : 'Inside'}${reservationDetails?.deal?.unit?.floor === 1 ? ', First Floor' : (reservationDetails?.deal?.unit?.floor ?? 0) > 1 ? ', Upper' : ''}` : '')} />
                                                    </ListItem>
                                                </List>
                                            </Grid>


                                            <Grid size={{ xs: 12, md: 3 }}>
                                                <List>
                                                    <ListItem>
                                                        <ListItemText primary='Monthly Rent' secondary={type === 1 ? (rentalData?.rent) : (`$${reservationDetails?.deal?.quoted_price.toFixed(2)}`)} />
                                                    </ListItem>
                                                </List>
                                            </Grid>

                                        </Grid>
                                        <Grid my={2} container spacing={2}>
                                            <Grid size={{ xs: 12, md: 3 }}>
                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                    <DatePicker
                                                        label="Rental Start Date"
                                                        slotProps={{
                                                            textField: {
                                                                size: 'small',

                                                            },
                                                            field: {
                                                                readOnly: true
                                                            }
                                                        }}
                                                        minDate={minDate}
                                                        maxDate={maxDate.add(maximumSelectableDate, 'day')}
                                                        onChange={(newValue) => handleDateChange(newValue)}
                                                        value={rentData?.start_date ? dayjs(rentData.start_date) : undefined}
                                                    />
                                                </LocalizationProvider>
                                            </Grid>
                                            <Grid size={{ xs: 12, md: 3 }}>
                                                <Autocomplete
                                                    disablePortal
                                                    options={month}
                                                    value={selectedMonth}
                                                    onChange={handleMonthChange}
                                                    getOptionLabel={(option: MonthOption) => option.label}
                                                    renderInput={(params) => <TextField {...params} label="Promotion Start" />}
                                                    disabled ={ispromo === 1}
                                                    size="small"
                                                />
                                            </Grid>

                                            <Grid size={{ xs: 12, md: 3 }} sx={{ minWidth: 0 }}>
                                                <Autocomplete
                                                    disablePortal
                                                    fullWidth
                                                    options={unitOptions}
                                                    getOptionLabel={(option) => option.unit_number ? option.unit_number.toString() : "No Unit"}
                                                    value={selectedUnit ? unitOptions.find((item: { external_id: string; unit_number: string }) => item.external_id === selectedUnit) ?? null : null}
                                                    onChange={handleUnitChange}
                                                    loading={unitloading || isDealUnitUpdateInProgress}
                                                    disabled={isDealUnitUpdateInProgress}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            label="Unit Number"
                                                            size="small"
                                                            error={noOthersAvailableType2}
                                                            helperText={noOthersAvailableType2 ? "Please return to the Facility Page, manage deal and select a new available unit." : ""}
                                                            InputProps={{
                                                                ...params.InputProps,
                                                                endAdornment: (
                                                                    <>
                                                                        {(unitloading || isDealUnitUpdateInProgress) ? <CircularProgress color="inherit" size={20} /> : null}
                                                                        {params.InputProps.endAdornment}
                                                                    </>
                                                                ),
                                                            }}
                                                        />
                                                    )}
                                                />
                                            </Grid>
                                            <Grid size={{ xs: 12, md: 3 }} sx={{ marginTop: '-20px' }}>
                                                <List>
                                                    <ListItem>
                                                        <ListItemText primary='Promotion' secondary={rentalData?.promotion?.trim() ? rentalData.promotion : "No Promo"} />
                                                       
                                                    </ListItem>
                                                </List>
                                            </Grid>
                                        </Grid>
                                        <Box textAlign={'right'}>
                                            {(isNonProduction || isTestFacility) && (
                                                <Link
                                                    sx={{ color: '#2400cb', cursor: 'pointer', ml: 4, mr: 2, fontStyle: 'italic' }}
                                                    onClick={() => TestLoadData("Information")}
                                                >
                                                    Load Test Data
                                                </Link>
                                            )}
                                            <Button
                                                variant='contained'
                                                color='primary'
                                                onClick={handleSubmit}
                                                disabled={isLoading} // Disable the button when loading
                                            >
                                                {isLoading ? <CircularProgress size={24} color='inherit' /> : 'Next'}
                                            </Button>
                                        </Box>
                                    </AccordionDetails>
                                </CustomAccordion>
                            </div>
                        </Box>
                        <Box mb={2}>
                            <CustomAccordion expanded={expand.Informationheader} >
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel1-content"
                                    id="panel1-header"
                                    onClick={() => handleAccordionClick('Informationheader')}
                                >
                                    <Typography variant="h3" color="text.secondary">Enter Customer Information
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <div id="header-info">
                                        <Box p={2}>
                                            {type === 1 && (<Stack mb={2} direction='row' spacing={1} justifyContent={'space-between'} alignItems={'center'} useFlexGap>
                                                <Link sx={{ color: '#2400cb', fontWeight: 500, cursor: 'pointer', fontStyle: 'italic' }}
                                                    onClick={() => handleLookupTenant()}
                                                >Lookup Occupant</Link>
                                            </Stack>
                                            )}
                                            <Box component="div">
                                                <Grid container spacing={3.5}>
                                                    <Grid size={{ xs: 12, sm: 6 }}>
                                                        <TextField
                                                            id="First-name"
                                                            name="customerinfofirstname"
                                                            label="First Name"
                                                            variant="outlined"
                                                            size="small"
                                                            value={rentData.customerinfofirstname}
                                                            onChange={handleChange}
                                                            error={errors.customerinfofirstname}
                                                            helperText={errors.customerinfofirstname ? "Invalid First name field" : ""}
                                                            fullWidth
                                                        />
                                                    </Grid>
                                                    <Grid size={{ xs: 12, sm: 6 }}>
                                                        <TextField id="Last-name" name="customerinfolastname" label="Last Name" variant="outlined" size="small" value={rentData.customerinfolastname}
                                                            onChange={handleChange}
                                                            error={errors.customerinfolastname}
                                                            helperText={errors.customerinfolastname ? "Invalid Last name field" : ""}
                                                            fullWidth
                                                        />
                                                    </Grid>
                                                    <Grid size={{ xs: 12, sm: 6 }}>
                                                        <TextField id="Address" name="customerinfoaddress1" label="Address"
                                                            variant="outlined" placeholder='Please Enter' size={'small'}
                                                            value={rentData.customerinfoaddress1}
                                                            onChange={handleChange}
                                                            error={errors.customerinfoaddress1}
                                                            helperText={errors.customerinfoaddress1 ? "Please Enter Address" : ""}
                                                            fullWidth />
                                                    </Grid>
                                                    <Grid size={{ xs: 12, sm: 6 }}>
                                                        <TextField id="Address-2" label="Address-2" name="customerinfoaddress2" variant="outlined"
                                                            placeholder='Please Enter' size={'small'} value={rentData.customerinfoaddress2}
                                                            onChange={handleChange}
                                                            error={errors.customerinfoaddress2}
                                                            helperText={errors.customerinfoaddress2 ? "Please Enter Address" : ""}
                                                            fullWidth />
                                                    </Grid>
                                                    <Grid size={{ xs: 12, sm: 6 }}>
                                                        <TextField id="city" label="City" name="customerinfocity" variant="outlined"
                                                            placeholder='Please Enter' size={'small'} value={rentData.customerinfocity}
                                                            onChange={handleChange}
                                                            error={errors.customerinfocity}
                                                            helperText={errors.customerinfocity ? "Please Enter City" : ""}
                                                            fullWidth />
                                                    </Grid>
                                                    <Grid size={{ xs: 12, sm: 6 }}>
                                                        <Autocomplete
                                                            autoHighlight
                                                            disablePortal
                                                            options={state}
                                                            getOptionLabel={(option) => option.label}
                                                            value={rentData.customerinfostate ? state.find(item => item.Id === rentData.customerinfostate) : null}
                                                            onChange={AutocompleteChange('customerinfostate')}
                                                            renderInput={(params) => <TextField {...params} label="State" size='small' />}
                                                        />
                                                    </Grid>

                                                    <Grid size={{ xs: 12, sm: 6 }}>
                                                        <TextField id="postal-code" label="Postal Code" name="customerinfoPostalcode" variant="outlined"
                                                            placeholder='Please Enter' size={'small'} value={rentData.customerinfoPostalcode} onChange={handlePostalCodeChange}
                                                            error={errors.customerinfoPostalcode}
                                                            helperText={errors.customerinfoPostalcode ? "Please Enter Postal Code (5-9 digits)" : ""}
                                                            fullWidth />
                                                    </Grid>
                                                    <Grid size={{ xs: 12, sm: 6 }}>
                                                        <TextField id="Phone" label="Phone" name="customerinfophone" variant="outlined" placeholder='Please Enter'
                                                            size={'small'} value={rentData.customerinfophone} onChange={handleChange} onBlur={handlePhoneBlur}
                                                            error={errors.customerinfophone}
                                                            helperText={errors.customerinfophone ? "Enter a valid 10-digit phone number" : ""}
                                                            fullWidth />
                                                    </Grid>
                                                    <Grid size={{ xs: 12, sm: 6 }}>
                                                        <TextField id="email" label="Email" name="customerinfoemail" variant="outlined" placeholder='Please Enter'
                                                            size={'small'} value={rentData.customerinfoemail} onChange={handleChange}
                                                            error={errors.customerinfoemail}
                                                            helperText={errors.customerinfoemail ? getEmailErrorMessage() : ""}
                                                            fullWidth />
                                                    </Grid>
                                                </Grid>
                                                <Divider sx={{ my: 4, mx: 'auto', width: '50%' }}><Typography variant='h3' color='text.secondary'>ID Capture</Typography></Divider>
                                                <Grid container spacing={3.5}>
                                                    <Grid size={{ xs: 12, sm: 6 }}>
                                                        <Autocomplete
                                                            disablePortal
                                                            options={idType}
                                                            getOptionLabel={(option) => option.label}
                                                            value={rentData.IdType ? idType.find(item => item.Id === rentData.IdType) : null}
                                                            onChange={AutocompleteChange('IdType')}
                                                            renderInput={(params) => <TextField {...params} label="ID Type" size='small' />}

                                                        />
                                                    </Grid>
                                                    <Grid size={{ xs: 12, sm: 6 }}>
                                                        <Autocomplete id="id-issuer"
                                                            autoHighlight
                                                            disablePortal
                                                            options={state}
                                                            getOptionLabel={(option) => option.label}
                                                            value={rentData.IdIssuer ? state.find(item => item.Id === rentData.IdIssuer) : null}
                                                            onChange={AutocompleteChange('IdIssuer')}
                                                            renderInput={(params) => <TextField {...params} label="ID Issuer" size='small' />}
                                                        />
                                                    </Grid>
                                                    <Grid size={{ xs: 12, sm: 6 }}>
                                                        <TextField id="id-number" label="ID Number" name="IdTNumber" variant="outlined" placeholder='Please Enter'
                                                            size={'small'} value={rentData.IdTNumber} onChange={handleChange}
                                                            error={errors.IdTNumber}
                                                            helperText={errors.IdTNumber ? "Please Enter Valid ID Number" : ""}
                                                            fullWidth />
                                                    </Grid>

                                                    <Box textAlign={'right'}>
                                                        {(isNonProduction || isTestFacility) && (
                                                            <Link
                                                                sx={{ color: '#2400cb', cursor: 'pointer', ml: 4, mr: 2, fontStyle: 'italic' }}
                                                                onClick={() => TestLoadData("Capture")}
                                                            >
                                                                Load Test Data
                                                            </Link>
                                                        )}
                                                    </Box>
                                                </Grid>
                                                <Divider sx={{ my: 4, mx: 'auto', width: '50%' }}><Typography variant='h3' color='text.secondary'>Emergency Contact</Typography></Divider>
                                                <Grid container spacing={3.5}>
                                                    <Grid size={{ xs: 12, sm: 6 }}>
                                                        <TextField id="Firstname" label="First Name" name="emergencyContactfirstname" variant="outlined"
                                                            placeholder='Please Enter' value={rentData.emergencyContactfirstname} size={'small'}
                                                            error={errors.emergencyContactfirstname}
                                                            helperText={errors.emergencyContactfirstname ? "Please Enter Emergency First Name" : ""}
                                                            onChange={handleChange} fullWidth />
                                                    </Grid>
                                                    <Grid size={{ xs: 12, sm: 6 }}>
                                                        <TextField id="Lastname" label="Last Name" name="emergencyContactlastname" variant="outlined"
                                                            placeholder='Please Enter' value={rentData.emergencyContactlastname} size={'small'} onChange={handleChange}
                                                            error={errors.emergencyContactlastname}
                                                            helperText={errors.emergencyContactlastname ? "Please Enter Emergency Last Name" : ""}
                                                            fullWidth />
                                                    </Grid>
                                                    <Grid size={{ xs: 12, sm: 6 }}>
                                                        <TextField id="phone" label="Phone" name="emergencyContactphone" variant="outlined" placeholder='Please Enter' value={rentData.emergencyContactphone} size={'small'}
                                                            onChange={handleChange} onBlur={handlePhoneBlur}
                                                            error={errors.emergencyContactphone}
                                                            helperText={errors.emergencyContactphone ? "Enter a valid 10-digit phone number" : ""}
                                                            fullWidth />
                                                    </Grid>
                                                    <Box textAlign={'right'}>
                                                        {(isNonProduction || isTestFacility) && (
                                                            <Link
                                                                sx={{ color: '#2400cb', cursor: 'pointer', ml: 4, mr: 2, fontStyle: 'italic' }}
                                                                onClick={() => TestLoadData("Emergency")}
                                                            >
                                                                Load Test Data
                                                            </Link>
                                                        )}
                                                    </Box>
                                                </Grid>
                                                <Divider sx={{ my: 4, mx: 'auto', width: '50%' }}><Typography variant='h3' color='text.secondary'>Military Status</Typography></Divider>
                                                <Grid container spacing={3.5}>
                                                    <Grid size={{ xs: 12, sm: 6 }}>
                                                        <Autocomplete
                                                            disablePortal
                                                            options={Status}
                                                            getOptionLabel={(option) => option.label}
                                                            value={rentData.militaryStatus ? Status.find(item => item.Id === rentData.militaryStatus) : null}
                                                            onChange={AutocompleteChange('militaryStatus')}
                                                            renderInput={(params) => <TextField {...params} label="Military Status" size='small' />}
                                                        />
                                                    </Grid>
                                                    {(rentData.militaryStatus === '4' || rentData.militaryStatus === '5') && (
                                                        <>
                                                            <Grid size={{ xs: 12, sm: 6 }}>
                                                                <Autocomplete
                                                                    disablePortal
                                                                    options={branches}
                                                                    getOptionLabel={(option) => option.label}
                                                                    value={rentData.militaryStatusbranch ? branches.find(item => item.Id === rentData.militaryStatusbranch) : null}
                                                                    onChange={AutocompleteChange('militaryStatusbranch')}
                                                                    renderInput={(params) => <TextField {...params} label="Branch" size='small' />}
                                                                />
                                                            </Grid>
                                                            <Grid size={{ xs: 12, sm: 6 }}>
                                                                <TextField
                                                                    id="id-number"
                                                                    name="militaryStatusidnumber"
                                                                    label="Id Number"
                                                                    variant="outlined"
                                                                    placeholder="Please Enter"
                                                                    size="small"
                                                                    onChange={handleChange}
                                                                    value={rentData.militaryStatusidnumber}
                                                                    error={errors.militaryStatusidnumber}
                                                                    helperText={errors.militaryStatusidnumber ? "Military ID number should not be less than 10 digits" : ""}
                                                                    fullWidth
                                                                //disabled={rentData.militaryStatusbranch === '4' || rentData.militaryStatusbranch === '5'}
                                                                />
                                                            </Grid>
                                                        </>
                                                    )}
                                                </Grid>
                                                <Divider sx={{ my: 4, mx: 'auto', width: '50%' }}><Typography variant='h3' color='text.secondary'>Liens and Lien Holders</Typography></Divider>

                                                <FormControl sx={{ mb: 3, flexDirection: 'row', gap: 4, flexWrap: 'wrap', alignItems: 'center' }}>
                                                    <FormLabel sx={{ fontWeight: 500 }} id="lien-status">Does anything you're going to store have a lien on
                                                        it?</FormLabel>
                                                    <RadioGroup
                                                        row
                                                        aria-labelledby="lien-Veteran"
                                                        name="isLians"
                                                        onChange={handleChange}
                                                        value={rentData.isLians}
                                                    >
                                                        <FormControlLabel
                                                            value="yes"
                                                            control={<Radio />}
                                                            label="Yes"
                                                            labelPlacement="end"
                                                        />
                                                        <FormControlLabel
                                                            value="no"
                                                            control={<Radio />}
                                                            label="No"
                                                            labelPlacement="end"
                                                        />
                                                    </RadioGroup>
                                                </FormControl>
                                                {rentData.isLians === 'yes' && (
                                                    <>
                                                        <Typography mb={2} fontWeight={500} color='text.secondary'>
                                                            If there are any lien holders, parties that hold a security interest and/or third-party owners of any personal property the tenant intends to store, enter them below (leave blank if not). Include a name and address for each party.
                                                        </Typography>
                                                        <textarea
                                                            placeholder='Type a quick note here...'
                                                            style={{ padding: '16px', minWidth: '100%', width: '100%', maxWidth: '100%', minHeight: '80px', maxHeight: '120px', borderColor: 'rgba(0, 0, 0, 0.23)', fontFamily: "'Poppins', sans-serif", fontSize: 14, }} id="comments" name="comments" rows={4} cols={50}
                                                            value={rentData.comments} // controlled input
                                                            onChange={(e) => setrentData({ ...rentData, comments: e.target.value })} // update state
                                                        />
                                                    </>
                                                )}
                                                <Divider sx={{ my: 4, mx: 'auto', width: '50%' }}><Typography variant='h3' color='text.secondary'>Property Being Stored</Typography></Divider>
                                                <FormGroup sx={{ flexDirection: 'row', mx: 3, flexWrap: 'wrap' }}>
                                                    <FormControlLabel control={<Checkbox checked={checkedItems.includes('Household')} onChange={handleCheckboxChange} name="Household" />} label="Household" />
                                                    <FormControlLabel control={<Checkbox checked={checkedItems.includes('Clothing')} onChange={handleCheckboxChange} name="Clothing" />} label="Clothing" />
                                                    <FormControlLabel control={<Checkbox checked={checkedItems.includes('Furniture')} onChange={handleCheckboxChange} name="Furniture" />} label="Furniture" />
                                                    <FormControlLabel control={<Checkbox checked={checkedItems.includes('Office')} onChange={handleCheckboxChange} name="Office" />} label="Office" />
                                                    <FormControlLabel control={<Checkbox checked={checkedItems.includes('Commercial')} onChange={handleCheckboxChange} name="Commercial" />} label="Commercial" />
                                                    <FormControlLabel control={<Checkbox checked={checkedItems.includes('Other')} onChange={handleCheckboxChange} name="Other" />} label="Other" />
                                                </FormGroup>
                                                {isOtherChecked ? (<TextField
                                                    label="Comments"
                                                    value={rentData.Otherproperitys}
                                                    onChange={commentChange}
                                                    placeholder="Enter your comments"
                                                    multiline // This renders a <textarea>
                                                    rows={4} // Optional: set the number of rows (height) of the textarea
                                                    fullWidth
                                                />) : ""}
                                                <Box my={3} textAlign={'right'}>
                                                    <Button variant='contained' sx={{ ml: 4 }} onClick={() => validation('Insuranceheader')}>Next</Button>
                                                </Box>
                                            </Box>
                                        </Box>
                                    </div>
                                </AccordionDetails>
                            </CustomAccordion>

                            {Islookup ? (<CustomAccordion defaultExpanded>
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel1-content"
                                    id="panel1-header"
                                >
                                    <div id="occupant-info">
                                        <Typography variant="h3" color="text.secondary">Search Occupant
                                        </Typography>
                                    </div>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Box py={2} style={{ width: '100%', height: '300px' }}>
                                        <Grid2 size={{ xs: 12, md: 12 }}>
                                            <TextField
                                                id="First-namesearch"
                                                name="firstnamesearch"
                                                label="First Name"
                                                variant="outlined"
                                                size="small"
                                                value={searchdata.firstnamesearch}
                                                onChange={handleSearchChange}
                                                onKeyDown={(e) => e.key === 'Enter' && handleLookupTenantSearch()}
                                                sx={{ width: '250px', marginRight: '10px', marginBottom: '16px' }}
                                                inputRef={firstNameInputRef}
                                            />
                                            <TextField
                                                id="last-namesearch"
                                                name="lastnamesearch"
                                                label="Last Name"
                                                variant="outlined"
                                                size="small"
                                                value={searchdata.lastnamesearch}
                                                onChange={handleSearchChange}
                                                onKeyDown={(e) => e.key === 'Enter' && handleLookupTenantSearch()}
                                                sx={{ width: '250px', marginRight: '10px', marginBottom: '16px' }}
                                            />
                                            <TextField
                                                id="email-search"
                                                name="emailsearch"
                                                label="Email"
                                                variant="outlined"
                                                size="small"
                                                value={searchdata.emailsearch}
                                                onChange={handleSearchChange}
                                                onKeyDown={(e) => e.key === 'Enter' && handleLookupTenantSearch()}
                                                sx={{ width: '350px', marginRight: '10px', marginBottom: '16px' }}
                                            />
                                        </Grid2>
                                        <Grid2 size={{ xs: 12, md: 12 }}>
                                            <TextField
                                                id="accesscode-search"
                                                name="accesscodesearch"
                                                label="Access Code"
                                                variant="outlined"
                                                size="small"
                                                value={searchdata.accesscodesearch}
                                                onChange={handleSearchChange}
                                                onKeyDown={(e) => e.key === 'Enter' && handleLookupTenantSearch()}
                                                sx={{ width: '250px', marginRight: '10px', marginBottom: '16px' }}
                                            />
                                            <TextField
                                                id="phone-search"
                                                name="phonesearch"
                                                label="Phone"
                                                variant="outlined"
                                                size="small"
                                                value={searchdata.phonesearch}
                                                onChange={handleSearchChange}
                                                onKeyDown={(e) => e.key === 'Enter' && handleLookupTenantSearch()}
                                                sx={{ width: '250px', marginRight: '10px', marginBottom: '16px' }}
                                            />
                                            <Button
                                                variant='contained'
                                                size='small'
                                                sx={{ ml: 1 }}
                                                onClick={handleLookupTenantSearch}
                                            >
                                                Search
                                            </Button>
                                        </Grid2>
                                    </Box>
                                    <Box sx={{ height: '30px' }} />
                                    {isgrid && (
                                        <>
                                            <Typography variant="h3" color="text.secondary">
                                                Pick an Occupant
                                            </Typography>
                                            <Box py={2} sx={{ width: '100%', height: '600px' }}>
                                                {isFetching ? (
                                                    <Box
                                                        sx={{
                                                            display: "flex",
                                                            justifyContent: "center",
                                                            alignItems: "center",
                                                            height: "70vh",
                                                        }}
                                                    >
                                                        <CircularProgress />
                                                    </Box>
                                                ) : (
                                                    <DataGrid
                                                        rows={gridData}
                                                        columns={colDefs}
                                                        disableColumnMenu
                                                        slots={{
                                                            noResultsOverlay: CustomNoResultsOverlay,
                                                            toolbar: CustomToolbar,
                                                        }}
                                                        initialState={{

                                                            columns: {
                                                                columnVisibilityModel: {
                                                                    // Hide columns some columns.  the other columns will remain visible
                                                                    address: false,
                                                                    email: false,
                                                                },
                                                            },
                                                        }}
                                                    />
                                                )}
                                            </Box>
                                        </>
                                    )}
                                </AccordionDetails>
                            </CustomAccordion>) : null}
                        </Box>
                        <Box mb={2}>
                            <CustomAccordion expanded={expand.Insuranceheader}>
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel1-content"
                                    id="panel1-header"
                                    onClick={() => handleAccordionClick('Insuranceheader')}
                                >
                                    <Typography variant="h3" color="text.secondary">Select Insurance
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Box mb={2} sx={{ backgroundColor: '#EBF3FF' }}>
                                        <Typography p={3} color="text.secondary"
                                            textAlign={'left'}
                                            dangerouslySetInnerHTML={{ __html: removeHtmlTags(insurencenotes || OperatorAlert[0]?.insurance_notes || '') }}
                                        />
                                    </Box>
                                    <Box p={2}>
                                        <Box component="div">
                                            {isInsurable ? (
                                                <FormControl component="fieldset">
                                                    <RadioGroup
                                                        aria-labelledby="insurance-selection"
                                                        name="selectinsurence"
                                                        value={selectinsurence}
                                                        onChange={handlecheckChange}
                                                    >
                                                        {prodectionplan.map((protectionPlan) => (
                                                            <FormControlLabel
                                                                key={protectionPlan.id}
                                                                value={protectionPlan.id.toString()}
                                                                control={<Radio />}
                                                                label={`${protectionPlan.name} - Coverage: $${protectionPlan.coverage} - $${protectionPlan.premium}/Month`}
                                                            />
                                                        ))}
                                                        <FormControlLabel
                                                            value="0"
                                                            control={<Radio />}
                                                            label="Decline"
                                                        />
                                                        {/* {IsEnableoccupant_TPP === 1 && (<FormControlLabel
                                                            value="1"
                                                            control={<Radio />}
                                                            label="Occupant Will Provide"
                                                        />)} */}
                                                    </RadioGroup>
                                                </FormControl>
                                            ) : (
                                                <Typography color="text.secondary">
                                                    No insurance available for this product type
                                                </Typography>
                                            )}
                                        </Box>
                                    </Box>

                                    <Box my={2} textAlign={'right'}>
                                        <Button
                                            variant="contained"
                                            onClick={() => validation('Merchandise')}>
                                            Next
                                        </Button>
                                    </Box>
                                </AccordionDetails>
                            </CustomAccordion>
                        </Box>
                        {/* Merchandise */}
                        <Box mb={2}>
                            <CustomAccordion expanded={expand.Merchandise}>
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel1-content"
                                    id="panel1-header"
                                    onClick={() => handleAccordionClick('Merchandise')}
                                >
                                    <Typography variant="h3" color="text.secondary">Merchandise Details
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Box p={2}>
                                        <TableContainer component={Box}>
                                            <Table size="small" aria-label="Merchandise details">
                                                <TableBody>
                                                    {merchandisedata?.map((item) => {
                                                        if (Number(item.in_stock) > 0) {
                                                            return (
                                                                <TableRow key={item.id} sx={{ border: 0 }}>
                                                        <TableCell align="left" sx={{ border: 0 }} >
                                                            <Typography fontWeight={500}>{item.name}</Typography>
                                                        </TableCell>
                                                        <TableCell align="right" sx={{ border: 0 }}>
                                                            <Typography>${Number(item.price).toFixed(2)}</Typography>
                                                        </TableCell>
                                                        <TableCell align="left" sx={{ border: 0 }}>
                                                            {Number(item.in_stock) < 10 && (
                                                                <Typography variant="body2" color="text.secondary">
                                                                    only {Number(item.in_stock)} remaining
                                                                </Typography>
                                                            )}
                                                        </TableCell>

                                                        <TableCell align="right" sx={{ border: 0, pl: 5 }}>
                                                            <Box
                                                                sx={{
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    justifyContent: "center",
                                                                    gap: 1,
                                                                }}
                                                            >
                                                                <Button
                                                                    variant="outlined"
                                                                    size="small"
                                                                    onClick={() => handleDecrement(Number(item.id))}
                                                                    sx={{
                                                                        borderColor: "#D3D3D3", // Light grey border
                                                                        color: "#000000", // Black text/icon
                                                                        backgroundColor: "#F5F5F5", // Light grey background
                                                                        "&:hover": {
                                                                            backgroundColor: "#E0E0E0", // Slightly darker grey on hover
                                                                            borderColor: "#C0C0C0",
                                                                        },
                                                                    }}
                                                                >
                                                                    <Typography sx={{ color: "#000000" }}>–</Typography>
                                                                </Button>




                                                                <Typography component="span" sx={{ mx: 1, fontSize: "0.875rem" }}>
                                                                    {item.quantity}
                                                                </Typography>

                                                                <Button
                                                                    variant="contained"
                                                                    size="small"
                                                                    onClick={() => handleIncrement(Number(item.id))}
                                                                >
                                                                    +
                                                                </Button>
                                                            </Box>
                                                        </TableCell>
                                                                </TableRow>
                                                            );
                                                        }
                                                        return null;
                                                    })}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </Box>
                                    <Box my={2} textAlign={'right'}>
                                        <Button
                                            variant="contained"
                                            onClick={() => validation('Instructionsheader')}>
                                            Next
                                        </Button>
                                    </Box>
                                </AccordionDetails>
                            </CustomAccordion>
                        </Box>
                        <Box mb={2}>
                            <CustomAccordion expanded={expand.Instructionsheader}  >
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel1-content"
                                    id="panel1-header"
                                    onClick={() => handleAccordionClick('Instructionsheader')}
                                >
                                    <Typography variant="h3" color="text.secondary">Review Move-in Instructions
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography color="text.primary"
                                        textAlign={'left'}
                                        dangerouslySetInnerHTML={{ __html: moveininstruction }}
                                    />

                                    <Box my={2}>
                                        <Stack direction="row" spacing={2} justifyContent="space-between" alignItems="center" width="100%">
                                            {/* <Box flexGrow={1} display="flex" justifyContent="center">
                                                <Button
                                                    variant='contained'
                                                    color='primary'
                                                    onClick={speedrentcalc}
                                                    disabled={isLoading} // Disable the button when loading
                                                >
                                                    Speed Rent
                                                </Button>
                                            </Box> */}
                                            <Button variant="contained" onClick={() => validation('MoveIndetailsheader')}>
                                                Next
                                            </Button>
                                        </Stack>

                                    </Box>
                                </AccordionDetails>
                            </CustomAccordion>
                        </Box>
                        <Box mb={2}>
                            <CustomAccordion expanded={expand.MoveIndetailsheader}  >
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel1-content"
                                    id="panel1-header"
                                    onClick={() => handleAccordionClick('MoveIndetailsheader')}
                                >
                                    <Typography variant="h3" color="text.secondary">Review Summary of Move-in Details
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Box my={2} p={2} bgcolor={'common.white'} width={{ xs: '100%', md: '50%' }} mx={'auto'}>
                                        <TableContainer component={Box}>
                                            <Table sx={{ maxWidth: '100%' }} aria-label="Unit Details">
                                                <TableBody sx={{
                                                    '& .MuiTableCell-root': {
                                                        borderBottom: 'none',
                                                        padding: '8px 0px'
                                                    },
                                                    '& .MuiTableRow-root:last-child .MuiTableCell-root': {
                                                        borderTop: 'none'
                                                    },
                                                    '& .MuiTableRow-root': {
                                                        // padding: 0
                                                    },
                                                    '& .MuiTableCell-root:first-of-type': {
                                                        fontWeight: 500
                                                    }
                                                }}>
                                                    <TableRow>
                                                        <TableCell align="left"><Typography color='text.secondary' fontWeight={500}>Unit Size</Typography></TableCell>
                                                        <TableCell align="left">
                                                            <Typography>
                                                                {
                                                                    type === 1
                                                                        ? (rentalData?.unitSize)  // If type === 1, render rentalData?.unitSize
                                                                        : (
                                                                            reservationDetails?.deal.unit_dimensions
                                                                                ? reservationDetails.deal.unit_dimensions
                                                                                    .split(' x ')
                                                                                    .map(dim => `${dim}'`)
                                                                                    .join(' x ')
                                                                                : 'N/A'
                                                                        )
                                                                }
                                                            </Typography>

                                                        </TableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                        <TableCell align="left"><Typography color='text.secondary' fontWeight={500}>Feature</Typography></TableCell>
                                                        <TableCell align="left">
                                                            <Typography>
                                                                {type === 1 ?
                                                                    (rentalData?.features) : (`${reservationDetails?.deal?.unit?.is_climate === 1 ? 'Climate' : 'Inside'}
                                                                        ${reservationDetails?.deal?.unit?.floor === 1 ? ', First Floor' : ''}`)
                                                                }</Typography>
                                                        </TableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                        <TableCell align="left"><Typography color='text.secondary' fontWeight={500}>Monthly Rate</Typography></TableCell>
                                                        <TableCell align="left"><Typography>{type === 1 ? (rentalData?.rent) : (`$${reservationDetails?.deal?.quoted_price}.00`)}</Typography></TableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                        <TableCell align="left"><Typography color='text.secondary' fontWeight={500}>Promotion</Typography></TableCell>
                                                        <TableCell align="left"><Typography>{rentalData?.promotion}</Typography></TableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                        <TableCell align="left"><Typography color='text.secondary' fontWeight={500}>Promotion Start Date</Typography></TableCell>
                                                        <TableCell align="left"><Typography>{selectedMonth?.label || 'N/A'}</Typography></TableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                        <TableCell align="left"><Typography color='text.secondary' fontWeight={500}>Rental Start Date</Typography></TableCell>
                                                        <TableCell align="left">
                                                            <Typography>
                                                                {rentData?.start_date
                                                                    ? dayjs
                                                                        .tz(rentData?.start_date, validTimezone) // Treat start_date as local to the timezone
                                                                        .format('MMM D, YYYY')
                                                                    : 'N/A'}
                                                            </Typography>
                                                        </TableCell>
                                                    </TableRow>
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </Box>
                                    <Grid my={2} container spacing={2}>
                                        <Grid size={{ xs: 12, md: 6 }}>
                                            <Box mb={2} p={2} bgcolor={'common.white'} borderRadius={2} border={'1px solid #000'} borderColor={'divider'} >
                                                <Typography mb={2} color='text.secondary' variant='h3' fontWeight={700}>Transaction Details</Typography>
                                                {(() => {
                                                    const firstPeriod = transactionDetailsPeriodsData[0];
                                                    const tdCost = transactionDetailsCost;
                                                    const merchandiseCost = toAmount(tdCost?.merchandise);
                                                    const merchandiseTax = toAmount(tdCost?.merchandise_tax);
                                                    const dueNowAmount =
                                                        tdCost != null
                                                            ? toAmount(tdCost.pms_total_for_movein)
                                                            : (firstPeriod?.total ?? 0) + merchandiseCost + merchandiseTax;
                                                    const transactionPromotionAmountDisplay = `(${formatCurrency(Math.abs(firstPeriod?.promotion ?? 0))})`;
                                                    return (
                                                <TableContainer component={Box}>
                                                    <Table sx={{ maxWidth: '100%' }} aria-label="Transaction Detail">
                                                        <TableBody sx={{
                                                            '& .MuiTableCell-root': { borderBottom: 'none', padding: '12px' }, '& .MuiTableRow-root:last-child .MuiTableCell-root': {
                                                                borderTop: '1px solid',
                                                                borderColor: 'divider'
                                                            }
                                                        }}>
                                                            <TableRow>
                                                                <TableCell align="left"><Typography color='text.secondary' fontWeight={500}>First Month Rent</Typography></TableCell>
                                                                <TableCell align="right"><Typography>{formatCurrency(firstPeriod?.rent ?? 0)}</Typography></TableCell>
                                                            </TableRow>
                                                            <TableRow>
                                                                <TableCell align="left">
                                                                    <Typography color='text.secondary' fontWeight={500}>Promotion</Typography>
                                                                    {rentalData?.promotion?.trim() && (
                                                                        <Typography component='i' color='error.light' sx={{ fontSize: '1.1em', display: 'block' }}>{rentalData.promotion}</Typography>
                                                                    )}
                                                                </TableCell>
                                                                <TableCell align="right"><Typography>{transactionPromotionAmountDisplay}</Typography></TableCell>
                                                            </TableRow>
                                                            <TableRow>
                                                                <TableCell align="left"><Typography color='text.secondary' fontWeight={500}>Administrative Fee</Typography></TableCell>
                                                                <TableCell align="right"><Typography>{formatCurrency(firstPeriod?.fees ?? 0)}</Typography></TableCell>
                                                            </TableRow>
                                                            <TableRow>
                                                                <TableCell align="left">
                                                                    <Typography color='text.secondary' fontWeight={500}>Insurance</Typography>
                                                                    {rentData?.promoname?.trim() && (
                                                                        <Typography component='i' color='text.secondary' sx={{ fontSize: '1.1em' }}>{rentData.promoname}</Typography>
                                                                    )}
                                                                </TableCell>
                                                                <TableCell align="right"><Typography>{formatCurrency(firstPeriod?.insurance ?? 0)}</Typography></TableCell>
                                                            </TableRow>
                                                            {merchandiseCost > 0 && (
                                                                <TableRow>
                                                                    <TableCell align="left"><Typography color='text.secondary' fontWeight={500}>Merchandise</Typography></TableCell>
                                                                    <TableCell align="right"><Typography>{formatCurrency(merchandiseCost)}</Typography></TableCell>
                                                                </TableRow>
                                                            )}
                                                            <TableRow>
                                                                <TableCell align="left"><Typography color='text.secondary' fontWeight={500}>Rent Tax</Typography></TableCell>
                                                                <TableCell align="right"><Typography>{formatCurrency(firstPeriod?.tax ?? 0)}</Typography></TableCell>
                                                            </TableRow>
                                                            {merchandiseCost > 0 && (
                                                                <TableRow>
                                                                    <TableCell align="left"><Typography color='text.secondary' fontWeight={500}>Sales Tax</Typography></TableCell>
                                                                    <TableCell align="right"><Typography>{formatCurrency(merchandiseTax)}</Typography></TableCell>
                                                                </TableRow>
                                                            )}
                                                            <TableRow>
                                                                <TableCell align="left"><Typography color='text.secondary' fontWeight={700}>Due Now</Typography></TableCell>
                                                                <TableCell align="right"><Typography color='text.secondary' fontWeight={700}>{formatCurrency(dueNowAmount)}</Typography></TableCell>
                                                            </TableRow>
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                                    );
                                                })()}
                                            </Box>
                                        </Grid>
                                        <Grid size={{ xs: 12, md: 6 }}>
                                            <Box mb={2} p={2} bgcolor={'common.white'} borderRadius={2} border={'1px solid #000'} borderColor={'divider'}>
                                                <Stack mb={2} direction="row" justifyContent="space-between" alignItems="center">
                                                    <Typography color='text.secondary' variant='h3' fontWeight={700}>Recurring Monthly Cost</Typography>
                                                    <Stack alignItems="flex-start" spacing={0.25}>
                                                        <Stack direction="row" alignItems="center" spacing={1}>
                                                            <Typography color='text.secondary' fontWeight={600}>Payment Periods</Typography>
                                                            <IconButton
                                                                size="small"
                                                                onClick={decrementPeriods}
                                                                disabled={periods <= 0}
                                                                aria-label="decrease payment periods"
                                                            >
                                                                <RemoveIcon fontSize="small" />
                                                            </IconButton>
                                                            <TextField
                                                                type="number"
                                                                size="small"
                                                                value={periods}
                                                                onChange={handlePeriodsChange}
                                                                error={periodsFieldHasError}
                                                                onKeyDown={(event) => {
                                                                    if (['-', '+', 'e', 'E'].includes(event.key)) {
                                                                        event.preventDefault();
                                                                    }
                                                                }}
                                                                inputProps={{ min: 0, max: 11, step: 1, inputMode: 'numeric', readOnly: true }}
                                                                sx={periodsFieldSx}
                                                            />
                                                            <IconButton
                                                                size="small"
                                                                onClick={incrementPeriods}
                                                                disabled={periods >= 11}
                                                                aria-label="increase payment periods"
                                                            >
                                                                <AddIcon fontSize="small" />
                                                            </IconButton>
                                                        </Stack>
                                                        {periodsFieldHasError && (
                                                            <Typography color="error.main" variant="caption" fontWeight={500}>
                                                                Must be 0 for move-in
                                                            </Typography>
                                                        )}
                                                    </Stack>
                                                </Stack>
                                                <Stack spacing={0.5}>
                                                    {recurringPeriodsData.slice(1).map((period, index) => {
                                                        const isExpanded = expandedRecurringPeriods[period.key] ?? true;
                                                        const promotionText = period.promotion === 0
                                                            ? '$0.00'
                                                            : `(${formatCurrency(Math.abs(period.promotion))})`;
                                                        return (
                                                            <Box key={period.key} sx={{ borderTop: index === 0 ? 'none' : '1px solid', borderColor: 'divider', pt: 0.5 }}>
                                                                <Stack direction="row" justifyContent="space-between" alignItems="center">
                                                                    <Stack direction="row" alignItems="center" spacing={0.5}>
                                                                        <IconButton size="small" onClick={() => handleToggleRecurringPeriod(period.key)}>
                                                                            <ExpandMoreIcon sx={{ transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)' }} />
                                                                        </IconButton>
                                                                        <Typography color='text.secondary' fontWeight={600}>{period.title}</Typography>
                                                                    </Stack>
                                                                    <Typography color='text.secondary' fontWeight={700}>{formatCurrency(period.total)}</Typography>
                                                                </Stack>
                                                                {isExpanded && (
                                                                    <Box pl={5} pr={1} pb={1}>
                                                                        <Stack direction="row" justifyContent="space-between" alignItems="center">
                                                                            <Typography component={'i'} color='text.secondary'>Rent</Typography>
                                                                            <Typography color='text.secondary'>{formatCurrency(period.rent)}</Typography>
                                                                        </Stack>
                                                                        <Stack direction="row" justifyContent="space-between" alignItems="center">
                                                                            <Typography component={'i'} color='text.secondary'>Promotion</Typography>
                                                                            <Typography color='text.secondary'>{promotionText}</Typography>
                                                                        </Stack>
                                                                        <Stack direction="row" justifyContent="space-between" alignItems="center">
                                                                            <Typography component={'i'} color='text.secondary'>Insurance</Typography>
                                                                            <Typography color='text.secondary'>{formatCurrency(period.insurance)}</Typography>
                                                                        </Stack>
                                                                        <Stack direction="row" justifyContent="space-between" alignItems="center">
                                                                            <Typography component={'i'} color='text.secondary'>Fees</Typography>
                                                                            <Typography color='text.secondary'>{formatCurrency(period.fees)}</Typography>
                                                                        </Stack>
                                                                        <Stack direction="row" justifyContent="space-between" alignItems="center">
                                                                            <Typography component={'i'} color='text.secondary'>Tax</Typography>
                                                                            <Typography color='text.secondary'>{formatCurrency(period.tax)}</Typography>
                                                                        </Stack>
                                                                    </Box>
                                                                )}
                                                            </Box>
                                                        );
                                                    })}
                                                </Stack>
                                            </Box>
                                            {/* Merchandise List Box */}
                                            {totalQuantity !== 0 && (<Box mt={2} p={2} bgcolor={'common.white'} borderRadius={2} border={'1px solid #000'} borderColor={'divider'}>
                                                <Typography mb={2} color='text.secondary' variant='h3' fontWeight={700}>
                                                    Merchandise List
                                                </Typography>
                                                <TableContainer component={Box}>
                                                    <Table sx={{ maxWidth: '100%' }} aria-label="Merchandise List">
                                                        <TableHead>
                                                            <TableRow sx={{ bgcolor: 'grey.200' }}>
                                                                <TableCell sx={{ fontWeight: 700 }}>Name</TableCell>
                                                                <TableCell align="right" sx={{ fontWeight: 700 }}>Quantity</TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {merchandisedata
                                                                .filter((item) => item.quantity > 0)
                                                                .map((item) => (
                                                                    <TableRow key={item.id}>
                                                                        <TableCell>{item.name}</TableCell>
                                                                        <TableCell align="right">{item.quantity}</TableCell>
                                                                    </TableRow>
                                                                ))}
                                                        </TableBody>

                                                    </Table>
                                                </TableContainer>
                                            </Box>)}
                                        </Grid>
                                    </Grid>
                                    <Box my={2} textAlign={'right'}>
                                        <Button variant='contained' onClick={() => validation('Paymentheader')}>Next</Button>
                                    </Box>
                                </AccordionDetails>
                            </CustomAccordion>
                        </Box>
                        <Box mb={2}>
                            <CustomAccordion expanded={expand.Paymentheader}  >
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel1-content"
                                    id="panel1-header"
                                    onClick={() => handleAccordionClick('Paymentheader')}
                                >
                                    <Typography variant="h3" color="text.secondary">Take Payment and Rent</Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <TakePaymentAndRent
                                        cost={cost}
                                        rentData={rentData}
                                        setrentData={setrentData}
                                        FacilityId={FacilityId}
                                        merchandaisedata={selectedmerchandise}
                                        periods={periods}
                                        onPeriodsValidationError={() => setPeriodsValidationError(true)}
                                        onCustomerPhoneInvalid={() => {
                                            setErrors((prev) => ({ ...prev, customerinfophone: true }));
                                            handleNext('Informationheader');
                                            requestAnimationFrame(() => {
                                                document.getElementById('header-info')?.scrollIntoView({ behavior: 'smooth' });
                                            });
                                        }}
                                    />
                                </AccordionDetails>
                            </CustomAccordion>
                        </Box>
                    </Grid>
                    <Grid size={{ xs: 12, md: 4 }} >
                        <Box mb={2} p={2} bgcolor={'common.white'} borderRadius={2} boxShadow={1} borderTop={'4px solid'} borderColor={'primary.main'}>
                            <Typography mb={2} color='text.secondary' variant='h3' fontWeight={700}>Transaction Details</Typography>
                            {(() => {
                                const firstPeriod = transactionDetailsPeriodsData[0];
                                const tdCost = transactionDetailsCost;
                                const merchandiseCost = toAmount(tdCost?.merchandise);
                                const merchandiseTax = toAmount(tdCost?.merchandise_tax);
                                const dueNowAmount =
                                    tdCost != null
                                        ? toAmount(tdCost.pms_total_for_movein)
                                        : (firstPeriod?.total ?? 0) + merchandiseCost + merchandiseTax;
                                const transactionPromotionAmountDisplay = `(${formatCurrency(Math.abs(firstPeriod?.promotion ?? 0))})`;
                                return (
                            <TableContainer component={Box}>
                                <Table sx={{ maxWidth: '100%' }} aria-label="Transaction Detail">
                                    <TableBody sx={{
                                        '& .MuiTableCell-root': { borderBottom: 'none', padding: '12px' }, '& .MuiTableRow-root:last-child .MuiTableCell-root': {
                                            borderTop: '1px solid',
                                            borderColor: 'divider'
                                        }
                                    }}>
                                        <TableRow>
                                            <TableCell align="left"><Typography color='text.secondary' fontWeight={500}>First Month Rent</Typography></TableCell>
                                            <TableCell align="right"><Typography>{formatCurrency(firstPeriod?.rent ?? 0)}</Typography></TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell align="left">
                                                <Typography color='text.secondary' fontWeight={500}>Promotion</Typography>
                                                {rentalData?.promotion?.trim() && (
                                                    <Typography component='i' color='error.light' sx={{ fontSize: '1.1em', display: 'block' }}>{rentalData.promotion}</Typography>
                                                )}
                                            </TableCell>
                                            <TableCell align="right"><Typography>{transactionPromotionAmountDisplay}</Typography></TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell align="left"><Typography color='text.secondary' fontWeight={500}>Administrative Fee</Typography></TableCell>
                                            <TableCell align="right"><Typography>{formatCurrency(firstPeriod?.fees ?? 0)}</Typography></TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell align="left">
                                                <Typography color='text.secondary' fontWeight={500}>Insurance</Typography>
                                                {rentData?.promoname?.trim() && (
                                                    <Typography component='i' color='text.secondary' sx={{ fontSize: '1.1em' }}>{rentData.promoname}</Typography>
                                                )}
                                            </TableCell>
                                            <TableCell align="right"><Typography>{formatCurrency(firstPeriod?.insurance ?? 0)}</Typography></TableCell>
                                        </TableRow>
                                        {merchandiseCost > 0 && (
                                            <TableRow>
                                                <TableCell align="left"><Typography color='text.secondary' fontWeight={500}>Merchandise</Typography></TableCell>
                                                <TableCell align="right"><Typography>{formatCurrency(merchandiseCost)}</Typography></TableCell>
                                            </TableRow>
                                        )}
                                        <TableRow>
                                            <TableCell align="left"><Typography color='text.secondary' fontWeight={500}>Rent Tax</Typography></TableCell>
                                            <TableCell align="right"><Typography>{formatCurrency(firstPeriod?.tax ?? 0)}</Typography></TableCell>
                                        </TableRow>
                                        {merchandiseCost > 0 && (
                                            <TableRow>
                                                <TableCell align="left"><Typography color='text.secondary' fontWeight={500}>Sales Tax</Typography></TableCell>
                                                <TableCell align="right"><Typography>{formatCurrency(merchandiseTax)}</Typography></TableCell>
                                            </TableRow>
                                        )}
                                        <TableRow>
                                            <TableCell align="left"><Typography color='text.secondary' fontWeight={700}>Due Now</Typography></TableCell>
                                            <TableCell align="right"><Typography color='text.secondary' fontWeight={700}>{formatCurrency(dueNowAmount)}</Typography></TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </TableContainer>
                                );
                            })()}
                        </Box>
                        {/* Recurring Monthly Cost */}
                        <Box mb={2} p={2} bgcolor={'common.white'} borderRadius={2} boxShadow={1}>
                            <Stack mb={2} direction="row" justifyContent="space-between" alignItems="center">
                                <Typography color='text.secondary' variant='h3' fontWeight={700}>Recurring Monthly Cost</Typography>
                                <Stack alignItems="flex-start" spacing={0.25}>
                                    <Stack direction="row" alignItems="center" spacing={1}>
                                        <Typography color='text.secondary' fontWeight={600}>Periods</Typography>
                                        <IconButton
                                            size="small"
                                            onClick={decrementPeriods}
                                            disabled={periods <= 0}
                                            aria-label="decrease periods"
                                        >
                                            <RemoveIcon fontSize="small" />
                                        </IconButton>
                                        <TextField
                                            type="number"
                                            size="small"
                                            value={periods}
                                            onChange={handlePeriodsChange}
                                            error={periodsFieldHasError}
                                            onKeyDown={(event) => {
                                                if (['-', '+', 'e', 'E'].includes(event.key)) {
                                                    event.preventDefault();
                                                }
                                            }}
                                            inputProps={{ min: 0, max: 11, step: 1, inputMode: 'numeric', readOnly: true }}
                                            sx={periodsFieldSx}
                                        />
                                        <IconButton
                                            size="small"
                                            onClick={incrementPeriods}
                                            disabled={periods >= 11}
                                            aria-label="increase periods"
                                        >
                                            <AddIcon fontSize="small" />
                                        </IconButton>
                                    </Stack>
                                    {periodsFieldHasError && (
                                        <Typography color="error.main" variant="caption" fontWeight={500}>
                                            Must be 0 for move-in
                                        </Typography>
                                    )}
                                </Stack>
                            </Stack>
                            <Stack spacing={0.5}>
                                {recurringPeriodsData.slice(1).map((period, index) => {
                                    const isExpanded = expandedRecurringPeriods[period.key] ?? true;
                                    const promotionText = period.promotion === 0
                                        ? '$0.00'
                                        : `(${formatCurrency(Math.abs(period.promotion))})`;
                                    return (
                                        <Box key={period.key} sx={{ borderTop: index === 0 ? 'none' : '1px solid', borderColor: 'divider', pt: 0.5 }}>
                                            <Stack direction="row" justifyContent="space-between" alignItems="center">
                                                <Stack direction="row" alignItems="center" spacing={0.5}>
                                                    <IconButton size="small" onClick={() => handleToggleRecurringPeriod(period.key)}>
                                                        <ExpandMoreIcon sx={{ transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)' }} />
                                                    </IconButton>
                                                    <Typography color='text.secondary' fontWeight={600}>{period.title}</Typography>
                                                </Stack>
                                                <Typography color='text.secondary' fontWeight={700}>{formatCurrency(period.total)}</Typography>
                                            </Stack>
                                            {isExpanded && (
                                                <Box pl={5} pr={1} pb={1}>
                                                    <Stack direction="row" justifyContent="space-between" alignItems="center">
                                                        <Typography component={'i'} color='text.secondary'>Rent</Typography>
                                                        <Typography color='text.secondary'>{formatCurrency(period.rent)}</Typography>
                                                    </Stack>
                                                    <Stack direction="row" justifyContent="space-between" alignItems="center">
                                                        <Typography component={'i'} color='text.secondary'>Promotion</Typography>
                                                        <Typography color='text.secondary'>{promotionText}</Typography>
                                                    </Stack>
                                                    <Stack direction="row" justifyContent="space-between" alignItems="center">
                                                        <Typography component={'i'} color='text.secondary'>Insurance</Typography>
                                                        <Typography color='text.secondary'>{formatCurrency(period.insurance)}</Typography>
                                                    </Stack>
                                                    <Stack direction="row" justifyContent="space-between" alignItems="center">
                                                        <Typography component={'i'} color='text.secondary'>Fees</Typography>
                                                        <Typography color='text.secondary'>{formatCurrency(period.fees)}</Typography>
                                                    </Stack>
                                                    <Stack direction="row" justifyContent="space-between" alignItems="center">
                                                        <Typography component={'i'} color='text.secondary'>Tax</Typography>
                                                        <Typography color='text.secondary'>{formatCurrency(period.tax)}</Typography>
                                                    </Stack>
                                                </Box>
                                            )}
                                        </Box>
                                    );
                                })}
                            </Stack>
                        </Box>
                    </Grid>
                </Grid>
                <Dialog
                    open={isDialogOpen}
                    onClose={handleDialogClose}
                    maxWidth="md" // Set the maximum width of the dialog
                    fullWidth // Ensures the dialog uses the full width available within the maxWidth
                    PaperProps={{
                        style: { padding: '20px', borderRadius: '8px', width: '650px', maxWidth: '85%' }, // Reduced width
                    }}
                >
                    <DialogTitle>Success</DialogTitle>
                    <DialogContent>
                        <Typography variant="body1" paragraph>
                            Speed Rent calculation was successful! The System will now re-direct you back to the facility page.
                        </Typography>
                        <Typography variant="body1" paragraph>
                            A deal was also created just now. If further action is needed for this caller, then use the deal.
                        </Typography>
                    </DialogContent>
                    <DialogActions style={{ marginBottom: '10px', justifyContent: 'center' }}>
                        <Button
                            onClick={handleDialogClose}
                            variant="contained"
                            color="primary"
                            style={{
                                padding: '10px 40px', // Wider padding for a better oval look
                                borderRadius: '50px', // Oval shape
                                fontSize: '16px', // Adjust font size for appearance
                            }}
                        >
                            Ok
                        </Button>
                    </DialogActions>
                </Dialog>
            </Box >

        </>
    );
};

export default RentAndReservationRent;
